{
  "settings" : {
    "calendar" : {
      "calendar_settings" : "Asetukset",
      "settings" : "Asetukset",
      "select_calendar_type" : "Valita Kalenterin tyyppi",
      "add_new_calendar_group" : "Lisätä uusi Ryhmä",
      "add_new_equipment" : "Lisätä uusi Laitteet",
      "new_calendar" : "uusi kalenteri",
      "calendar_group_description" : "Kalenteri Ryhmän avulla voit yhdistää useita kalentereita Järjestää ja Ryhmä tehokkaasti.",
      "group" : "Ryhmä",
      "manage_your_calendars_and_groups" : "Hallinnoida kalenterisi ja Ryhmä",
      "groups" : "Ryhmä",
      "create_group" : "Luoda Ryhmä",
      "create_calendar" : "Luoda kalenteri",
      "calendar_name" : "Kalenterin nimi",
      "group_duration" : "Ryhmä Kesto",
      "calendar_type" : "Kirjoittaa",
      "action" : "Toiminta",
      "round_robin" : "Vuorottelujako",
      "event" : "Tapahtuma",
      "group_name" : "Ryhmä nimi",
      "room_name" : "Huone nimi",
      "group_description" : "Ryhmä Kuvaus",
      "calendar_url" : "Kalenterin URL-osoite",
      "calendars" : "Kalenterit",
      "date_updated" : "Päivämäärä Päivitetty",
      "status" : "Tila",
      "action_dropdown" : "Toiminta Pudotus-",
      "calendar_list" : "Palvelut Jäsenet to",
      "edit" : "Muokata",
      "duplicate" : "Kopioida",
      "copy_embed_code" : "Kopioida Upotettu koodi",
      "copy_permanent_link" : "Kopioida pysyvä Linkki",
      "copy_new_slug_link" : "Kopioida Ajanvarauslinkki",
      "copy_scheduling_link" : "Kopioida Ajanvarauslinkki (vanha, poistettu käytöstä)",
      "deactivate_calendar" : "Keskeyttää kalenteri",
      "move_to_group" : "Siirtää Ryhmä",
      "delete_calendar" : "Poista kalenteri",
      "delete_group" : "Poista",
      "delete_this_group" : "Poista tämä Ryhmä",
      "activate_calendar" : "käynnistää Kalenteri",
      "duration" : "Kesto",
      "all" : "aikana",
      "draft" : "Luonnostella",
      "inactive" : "Inaktiivinen",
      "active" : "Dynaaminen",
      "actions" : "toiminnot",
      "rearrange_calendars" : "Siirtää Kalenterit",
      "deactivate_all_calendars_in_group" : "Keskeyttää Kalenterit in Ryhmä",
      "activate_all_calendars_in_group" : "aloituksesi kalenterit in Ryhmä",
      "no_groups_found" : "Hakeasi ei vastannut yhtään kalenterista Ryhmä.",
      "no_groups_in_location" : "Ryhmä Järjestää kalenterisi Tykätä Kansio. Lisätä kalentereita Ryhmään ja Jakaa a Yksilölliseen Ajanvarauslinkkiin, vuokraamalla Buukkaaja Valita - useita kalentereita.",
      "no_calendars_found" : "Aloita Kautta kalenteri Kautta Luotu uusi kalenteri.",
      "no_calendars_found_search" : "Hakeasi ei vastannut yhtään kalenteria.",
      "delete_calendar_message" : "Sinä/Te're - kalenterin poistamiseksi. Kun Sinä/Te Näkymät poista se poistaa myös sen Tapaation.",
      "delete_calendar_message_title" : "Poistetaanko tämä kalenteri?",
      "duplicate_calendar_message" : "Sinä/Te're - Kopioida-kalenteriin. Tämä Luoda uuden kalenterin, jolla on samat Asetukset kuin Valittu-kalenterissa.",
      "duplicate_calendar_message_title" : "Kopioida tämä kalenteri?",
      "no_calendars_found_title" : "Ei kalentereita",
      "no_groups_in_location_title" : "Ei ryhmäläisiä",
      "delete_group_confirmation_title" : "Poistetaanko tämä Ryhmä?",
      "delete_group_confirmation" : "Haluatko varmasti Sinä/Te varma poistaa Valittu-ryhmän?",
      "delete_group_confirmation_checkbox_title" : "Poista Jäsenet-kalenterit ja Tapaaminen",
      "delete_group_confirmation_checkbox_description" : "Vaihtoehdon valitseminen poistaa myös in Ryhmän kalenterit sekä tämän kalenterin Tapaaminen in kalentereista.",
      "group_status_message_title" : "{status} ryhmän & Jäsenet kalenterit?",
      "calendar_status_message_title" : "{status} tämä kalenteri?",
      "calendar_status_message" : "Sinä/Te're – {status} kalenteriin",
      "group_status_active_message" : "Haluatko varmasti Sinä/Te perustaa tämän ryhmän? Ryhmän sisällä olevat kalenterit ovat myös Käytössä ja varattavissa",
      "group_status_inactive_message" : "Haluatko Sinä/Te varma Sinä/Te keskeyttää tämän ryhmän? Ryhmän kalenterit ovat myös Poistettuna ja varattavissa",
      "coming_soon" : "Tulossa pian",
      "select" : "Valita",
      "15mins" : "15 minuuttia",
      "cancel" : "Peruuttaa",
      "save" : "Arkistoida",
      "create" : "Luoda",
      "select_calendar_group" : "Valita Ryhmä",
      "move_calendar_confirmation" : "Ole hyvä Muistiinpano, että vanha Linkki lopettaisi toimintansa kerran Sinä/Te Edetä Muuttaan kanssa. Vahvista Kautta valitsemalla Valintaruutu.",
      "previously_called_unassigned" : " (Aiemmin kutsuttu määrittämättömäksi)",
      "scheduling_type" : "Valita Kalenterin tyyppi",
      "scheduling_type_description" : "Valita a Kalenterin tyyppi to Määrittää kalenterisi ja Mukauttaa miten Tapaaminen ovat Ajoitettuja.",
      "service_menu_name" : "Palveluvalikon kohteen nimi",
      "template" : "Mallipohja",
      "select_template" : "Valitse mallipohja",
      "group_url" : "Ryhmän URL",
      "template_description" : "Sinä/Te nyt on valittavissasi Valita Tai Klassinen Tai Neo Ryhmä Katsoan -mallipohjat",
      "rooms" : "Huone",
      "rooms_name" : "Nimi",
      "rooms_description" : "Kuvaus",
      "rooms_modal_description" : "Lisätä Tai Muokata Huone",
      "rooms_capacity" : "Yhteensä",
      "no_rooms_in_location_title" : "Ei Huone kohteita",
      "no_rooms_in_location" : "Ei Huone löytöä in sijainnissa",
      "no_equipments_in_location" : "Ei Laitteet löydät in sijainnissa",
      "equipments" : "Laitteet",
      "equipment_name" : "Nimi",
      "equipment_name_search" : "Laitteet nimi",
      "equipment_description" : "Kuvaus",
      "equipment_modal_description" : "Lisätä Tai Muokata an Laitteet",
      "add_equipment" : "Lisätä/ Muokata Laitteet",
      "add_room" : "Lisätä/ Muokata Huone",
      "equipment_quantity" : "Yhteensä",
      "equipment_outOfService" : "- Palvelun määrä",
      "no_equipments_in_location_title" : "Ei Laitteet löydät",
      "delete_this_equipment" : "Poista tämä Laitteet",
      "delete_this_rooms" : "Poista tämä Huone",
      "delete_equipment_confirmation" : "Haluatko Sinä/Te varma, Sinä/Te poistaa tämän Laitteet? Tämä on myös Poistettu - Kolmannen osapuolen kalenterit.",
      "delete_rooms_confirmation" : "Haluatko Sinä/Te sure, Sinä/Te poistaa tämän Huoneen? Tämä on myös Poistettu - Kolmannen osapuolen kalenterit.",
      "add_new_calendar_equipments" : "Lisätä uusia Laitteet",
      "no_equipments_found" : "Hakeasi ei vastannut mitään Laitteetteja.",
      "no_rooms_found" : "Hakeasi ei vastannut yhtään huonetta.",
      "add_new_calendar_rooms" : "Lisätä uusi Huone",
      "rooms_disable" : "Poistaa käytöstä Huone käytöstä",
      "equipments_disable" : "Poistaa käytöstä Laitteet käytöstä",
      "equipments_activate" : "avaaä Laitteet",
      "rooms_activate" : "avoin Huone",
      "create_equipments" : "Luoda Laitteet",
      "create_rooms" : "Luoda Huone",
      "select_calendar_rooms_title" : "Valita kalenteri",
      "select_calendar_rooms_description" : "Sinä/Te voi Valita useita kalentereita Kumpaniin Huoneella",
      "select_calendar_equipments_title" : "Valita kalenteri",
      "select_calendar_equipments_description" : "Sinä/Te voi Valita yhden kalenterin Kumpaniin Laitteilla",
      "disable_equipment_title" : "{status} Laitteet",
      "disable_room_title" : "{status} huone",
      "equipments_status_message" : "Haluatko varmasti Sinä/Te {status} tälle Laitteelle?",
      "rooms_status_message" : "Haluatko Sinä/Te varma, että Sinä/Te {status} tässä huoneessa?",
      "calendar_resource_disclaimer" : "Tämä voi vaikuttaa Päällä Jäsenet -palvelukalentereihin.",
      "equipment_disclaimer" : "Muistiinpano: Laitteiden ottaminen käyttöön myöhemmin Yhdistä palauttaa sen automaattisesti kalentereihin, joiden kanssa se on Jäsenet",
      "room_disclaimer" : "Muistiinpano: Huoneen ottaminen käyttöön myöhemmin Yhdistä uudelleentaa sen automaattisesti kalentereihin, joiden kanssa se on Jäsenet",
      "equipment_tab_name" : "Laitteet",
      "rooms_tab_name" : "Huone",
      "manage_your_rooms" : "Hallinnoida Huone yrityksellesi tässä",
      "manage_your_equipments" : "Hallinnoida Laitteet yrityksellesi tässä",
      "select_service_calendar_description_equipments" : "Sinä/Te voi Valita Laitteilla Kumpaniin useita palvelukalentereita",
      "select_service_calendar_description_rooms" : "Sinä/Te voi Valita Huoneella Kumpaniin useita palvelukalentereita",
      "service_menus" : "Palveluvalikko",
      "manage_your_calendars_groups_and_service_menus" : "Hallinnoida kalenterisi, Ryhmä ja palveluvalikko",
      "new_service_menu" : "Luoda palveluvalikko",
      "deactivate_service_menu" : "Keskeyttää palveluvalikko",
      "delete_service_menu" : "Poista tämä palveluvalikko",
      "delete_service_menu_confirmation" : "Haluatko varmasti Sinä/Te poistaa tämän palveluvalikon?",
      "service_menu_status_message_title" : "{status} tästä palveluvalikosta?",
      "service_menu_status_message" : "Sinä/Te're – kohteeseen {status} Palveluvalikko",
      "no_service_menus_in_location_title" : "Luoda mukautettu palveluvalikko",
      "add_new_service_menu" : "Lisätä uusi palveluvalikko",
      "no_service_menus_in_location" : "Aloita Kautta Luotu a uusi palveluvalikko ja lisää siihen Ryhmä",
      "no_service_menu_found" : "Ei palveluvalikkoa",
      "no_service_menu_found_desc" : "Hakeasi ei vastannut yhtään palveluvalikkoa.",
      "apply" : "Käyttää",
      "troubleshoot_calendar" : "Etsiä vika kalenterin vianetsintä",
      "round_robin_booking" : "Round Robin",
      "round_robin_description" : "Jakaa Tapauksen Ryhmä Jäseneille in Järjestään.",
      "round_robin_example" : "Esim. Myynti-puhelut, Perehdytys-istunnot.",
      "unassigned_booking" : "Tapahtuma",
      "unassigned_description" : "Ajoittaa fyysisille tapahtumille ilman Isäntä Suhdea.",
      "unassigned_example" : "Esim. Konferenssit, Julkinen-seminaarit, messut.",
      "event_booking_alert_title" : "Tärkeää",
      "event_booking_alert_message" : "Tällä kalenterin tyypillä on keskeisiä eroja",
      "event_booking_know_more" : "Lisätietoja",
      "event_booking_tooltip_title" : "Asiat, jotka on hyvä tietää:",
      "event_booking_tooltip_content" : "• Dynaamisia kokouslinkkityökaluja ei tueta (esim. Zoom/Google Meet/MS Teams).\n• Käyttäjää ei voi määrittää.\n• Tapahtumat eivät synkronoidu käyttäjän kalenteriin oletusarvoisesti..\n• Vain yksi Google Calendar voidaan synkronoida ulkoisen synkronoinnin kautta.\n• Ristiriitakalentereita ei tueta.",
      "class_booking" : "Luokka varaus",
      "class_booking_description" : "Yksi Isäntä tapaa useita Jäsenettejä.",
      "class_booking_example" : "Esim.: Webinaarit, Ryhmä Kurssit, online Kurssit.",
      "collective_booking" : "KOLLEKTIIVINEN Ajanvaraus",
      "collective_booking_description" : "Useat isännät tapaavat yhdellä Jäsenetillä.",
      "collective_booking_example" : "Esim.: Paneelihaastattelut, valiokuntaarvostelut.",
      "service_booking" : "Palvelun varaus",
      "service_booking_description" : "Saumaton Ajoittaa palvelupohjaiselle yritykselle.",
      "service_booking_example" : "Esim. Spa Tapaaminen, korjauspalvelut, konsultaatiot.",
      "personal_booking" : "Henkilökohtainen ajanvaraus",
      "personal_booking_description" : "Ajoittaa yksi-Päällä-yksi tapaamiset tietyn Ryhmä Jäsenetin kanssa.",
      "personal_booking_example" : "Esim. Asiakastapaamiset, Yksityinen-neuvottelut.",
      "personal" : "Henkilökohtainen",
      "explore_more_types" : "Katso lisää Kategoriat",
      "no_calendars_added" : "Ei kalentereita – Kokoelma Yksi ylös!",
      "no_calendars_added_description" : "Luoda ensimmäinen kalenterisi, joka alkaa Ajoittaa vaivattomasti.",
      "no_groups_added" : "Ei ryhmiä – Aloita organisointi!",
      "no_calendars_yet" : "Ei vielä kalentereita",
      "no_groups_yet" : "Ei vielä ryhmää",
      "no_calendars_access" : "Kalentereita ei ole vielä luotu. Kun kalenteri on Luotu, se näkyy tässä. Sinä/Tella ei ole Pääsyä Luodaan kalenteri – ota yhteyttä Ylläpitäjä Josin, jota tarvitset.",
      "no_groups_access" : "Ei Ryhmää ole vielä Määrittää. Kun Ryhmä on Luotu, se näkyy tässä. Sinä/Te ei ole Pääsyä Luoda a ryhmään – ota yhteyttä Ylläpitäjä Josin, jota tarvitaan.",
      "no_groups_added_description" : "Käytä Ryhmää pitääksesi kalenterisi jäsenneltynä. Lisätä kalentereita Ryhmä- ja Jakaa a Yksilöllinen ryhmän Ajanvarauslinkki Yksinkertaiseen-varaukseen.",
      "group_success_message" : "Ryhmä on Luotu. Sinä/Te voi nyt Sisällyttää kalenterit tähän ryhmään.",
      "choose_calendars" : "Valita kalenterit",
      "do_it_later" : "Teen sen myöhemmin",
      "add_calendars_to_group" : "Lisätä kalentereita Ryhmä",
      "select_calendars_to_add" : "Ole hyvä ja Valita kalenterit Sinä/Te haluat Sisällyttää to the Ryhmän {name}",
      "add_calendars" : "Lisätä kalentereita",
      "continue" : "Jatkaa",
      "conflicting_calendars" : "Ristiriitaiset kalenterit",
      "conflicting_calendars_description" : "Perässä oleva kalenterit ovat jo osana - Muu Ryhmä. Haluatko Sinä/Te Siirtää ne uuteen Ryhmään, <b>{name}</b>?",
      "group_associated_with" : "Tämänhetkinen Ryhmä",
      "move_calendar_consent" : "Ottaa käyttöön Siirtää nämä kalenterit uuteen ryhmään.",
      "calendars_moved_successfully" : "Valittu-kalenterit on siirretty kohteeseen {name}.",
      "new_group" : "uusi Ryhmä",
      "back" : "Takaisin",
      "share_otl" : "Jakaa Linkki päivämääräsi, jolla on yksilöllinen tilanne, että Päättyä Jälkeen varaamalla voit varmistaa Hallinnoida Pääsy.",
      "copied_to_clipboard" : "Kopioitu leikepöydälle",
      "generate_link" : "Luoda uusi Linkki",
      "generate_link_error" : "Kertaluonteista linkkiä ei voitu tallentaa. Yritä uudelleen",
      "share_schedule_link" : " Ajanvarauslinkki on määrätietoinen Kautta the Kestolinkki. Muokata Kestolinkki ja Ajanvarauslinkki mukautuvat automaattisesti muutokseen.",
      "share_permanent_link" : "Ihanteellinen Suppilotiin, Verkkosivusto Uudelleenohjaukset, Tai Mainokset, pysyvä Linkki pysyy vakiona, ei vaikuta Kautta Kestolinkki Dynaaminen.",
      "copy" : "Kopioida",
      "share_embed_code" : "Sijaintia tämä Koodi in HTML {embedType}, jossa Sinä/Te haluat Widget si näkyvän.",
      "scheduling_link" : "Ajanvarauslinkki",
      "permanent_link" : "Pysyvä Linkki",
      "one_time_link" : "Yksi päivämäärä Linkki",
      "embed_code" : "Upotettu koodi",
      "loading" : "Ladataan...",
      "share_group" : "Jakaa Ryhmä",
      "edit_group" : "Muokata Ryhmä",
      "more_options" : "Lisää Valinnat",
      "share_calendar" : "Jakaa kalenteri",
      "edit_calendar" : "Muokata kalenteria",
      "troubleshoot_calendar_link" : "Etsiä vika kalenterin vianetsintä",
      "calendar_config_success" : "Sinä/Te on määrittänyt henkilökohtaisen/Ryhmä-kalenterisi",
      "close" : " Sulkea",
      "added_calendars" : "Lisätyt kalenterit",
      "select_calendars" : "Valita kalenteri(t)",
      "settings_confirmation" : "Edetä, vahvista nämä Dynaaminen.",
      "consent_checkbox_title" : "Ymmärrän ja hyväksyn nämä Dynaaminen",
      "confirm" : "Vahvista",
      "create_group_access_disabled" : "Sinä/Te ei ole Valtuutus Luoda a Ryhmään. Ota yhteyttä Ylläpitäjäsi for Pääsylle.",
      "create_calendar_access_disabled" : "Sinä/Tella ei ole Valtuutus Luodaan kalenteria. Ota yhteyttä Ylläpitäjäsi for Pääsylle.",
      "preview_booking_widget" : "Esikatselu Ajanvaraus-widget",
      "share_service_menu" : "Jakaa palveluvalikko",
      "back_message" : "Takaisin Luettelo",
      "service_calendars" : "Palvelukalenterit",
      "owned_by" : "Omistama Kautta",
      "owned_by_anyone" : "Kuka tahansa",
      "owned_by_me" : "Minä",
      "all_groups" : "koko Ryhmä",
      "all_calendars" : "päivän Kalenterit",
      "not_grouped" : "Ei ryhmitelty",
      "delete_group_desc" : "Haluatko varmasti Sinä/Te poistaa tämän ryhmän? Tämä poistaa myös tämän Ryhmän kalenterit Jäsenet.",
      "calendar_listing_title" : "Kalenterilistaus",
      "calendar_group_name" : "Kalenteri/ Ryhmä nimi",
      "success" : "Onnistui",
      "my_calendar" : "oma kalenteri"
    },
    "preferences" : {
      "preferences" : "Asetukset",
      "my_preferences" : "Oma Valinta",
      "account_preferences" : "Tilin asetukset",
      "user_preferences" : "Käyttäjät Asetukset",
      "set_preferences" : "Kokoelma Asetukset Tilille.",
      "scheduling_options" : "Ajoittaa Vallinnat",
      "meeting_location" : "Osallistua neuvotteluunin sijainti",
      "zoom" : "Zoom",
      "save_preferences" : "Arkistoida Asetukset",
      "in_app_preferences" : "Sovelluksen sisäinen Asetukset",
      "set_start_day" : "Kokoelma Asetukset Tykätä start Päivä sovellukselle",
      "view_options" : "Katsoa Valinnat",
      "services" : "Palvelut",
      "feature_toggle_aria" : "Ominaisuuden vaihto",
      "week_starts_on" : "Viikon alkamispäivä",
      "sunday" : "Sunnuntai",
      "widget_preferences" : "Widget Asetukset",
      "set_widget_language" : "Kokoelma Asetukset Tykätä Kieli for Widget",
      "language_and_region" : "Kieli ja Osavaltio",
      "language" : "Kieli",
      "english" : "Englanti",
      "time_format" : "Aikaformaatti",
      "time_format_value" : "PM",
      "monday" : "Maanantai",
      "custom_meeting_location" : "Mukautettu osallistua neuvotteluun sijainti",
      "view_appointments_in_1" : "Näytä tapaamiset kohteessa",
      "timezone_uses_details_1" : "Tämän aikavyöhykkeen avulla näytämme tapaamisajat koko sovelluksessa ja tapaamisiin liittyvissä sähköposteissasi – vain sinulle. Se ei vaikuta saatavuuteesi tai siihen, miten muut varaavat tapaamisia kanssasi.",
      "business_timezones_1" : "Yrityksen aikavyöhyke",
      "business_timezones_tooltip_1" : "Huomautus: Tämän vaihtoehdon valitseminen varmistaa, että katseluasetuksesi vastaavat valittua yrityksen aikavyöhykettä. Jos yrityksen aikavyöhyke muuttuu, katseluaikavyöhykkeesi muuttuu automaattisesti sitä vastaavaksi.",
      "recommended_timezones" : "Suositellut aikavyöhykkeet",
      "all_timezones" : "Kaikki aikavyöhykkeet"
    },
    "availability" : {
      "availability" : "Saatavuus",
      "my_availability" : "Oma Saatavuus",
      "my_availability_and_booking_rules" : "Saatavuus ja varauksen säännöt",
      "my_availability_and_booking_rules_description" : "Määritä saatavuus ja se, miten ja milloin tämä kalenteri hyväksyy varauksia – mukaan lukien kokousvälit, rajoitukset ja muut aikatauluvalinnat.",
      "account_availability" : "Tili Saatavuus",
      "timezone" : "Aikavyöhyke",
      "working_hours" : "Aukioloajat",
      "set_recurring_hours" : "Kokoelma sinun Toistuva-työtuntisi Osallistua neuvotteluuniin",
      "select_one" : "Valitse yksi",
      "sunday" : "Sunnuntai",
      "monday" : "Maanantai",
      "tuesday" : "Tiistai",
      "wednesday" : "Keskiviikko",
      "thursday" : "Torstai",
      "friday" : "Perjantai",
      "saturday" : "Lauantai",
      "widget_preferences" : "Widget Asetukset",
      "set_widget_language" : "Kokoelma Asetukset Tykätä Kieli for Widget",
      "language_and_region" : "Kieli ja Osavaltio",
      "language" : "Kieli",
      "english" : "Englanti",
      "copy_to_all" : "Kopioida to usealle",
      "save_availability" : "Arkistoida tuotteena",
      "add_time" : "Lisätä päivämäärä",
      "to" : "Vastaanottaja",
      "select_time" : "Valita päivämäärä",
      "add_user" : "Lisätä Käyttäjä",
      "accessRestricted" : {
        "header" : "Pääsy Yksityinen",
        "message" : "Sinä/Te eivät ole osa - tämä Tili. Jos haluat saada Pääsyn, Sisällyttää itsesi tähän Tili Kautta Toimisto Asetukset > Ryhmä > Muokata Ryhmä Jäsenet, ja määritä Tili kohtaan Roolit ja käyttöoikeudet",
        "contact_admin" : "Tämä sivu on vain Julkinen ylläpitäjille. Lisätietoja saat ottamalla yhteyttä Ylläpitäjään.",
        "button_text" : "Siirry Asetukset Toimisto"
      },
      "schedule" : {
        "edit_schedule" : "Muokkaa aikataulua",
        "schedule_name" : "Aikataulun nimi",
        "schedule_name_required" : "Aikataulun nimi on pakollinen",
        "timezone" : "Aikavyöhyke",
        "timezone_placeholder" : "Valitse yksi",
        "start_time" : "Alkamisaika",
        "end_time" : "Päättymisaika",
        "add_availability_hour" : "Lisää saatavuustunti",
        "remove_availability_hour" : "Poista saatavuustunti",
        "unavailable" : "Ei saatavilla",
        "schedule_created" : "Aikataulu luotu",
        "schedule_updated" : "Aikataulu päivitetty",
        "calendars_selected" : "{count} kalenteri",
        "calendars_selected_multiple" : "{count} kalenteria",
        "select_users_placeholder" : "Hae käyttäjiä",
        "edit_default_schedule" : "Muokkaa tätä aikataulua",
        "customize_event_type_schedule" : "Mukauta aikataulua vain tätä kalenteria varten",
        "multi_user_description" : "<b>{count} käyttäjää</b> on valittu. Päivitä heidän saatavuutensa kalenteriin <b>{calendar}</b>",
        "selected_calendar" : "valittu kalenteri",
        "edit_schedule_alert" : "Tässä tehdyt päivitykset otetaan käyttöön näissä:",
        "schedule" : "Ajoita",
        "no_availability" : "Ei saatavuutta",
        "date_specific_hours_show_more" : "lisää",
        "date_specific_hours_show_less" : "vähemmän",
        "date_specific_hours_recurring_meetings_enabled" : "Päivämääräkohtaisia tunteja ei voi lisätä, koska tämä aikataulu on yhdistetty kalenteriin, jossa toistuvat kokoukset ovat käytössä. Jatka poistamalla toistuvat kokoukset käytöstä.",
        "recurring_incompatible_with_date_hours" : "Toistuvia kokouksia ei voida ottaa käyttöön, koska käyttäjän aikataulussa on päivämääräkohtaisia tunteja, jotka eivät ole yhteensopivia.",
        "incompatible_schedule_with_recurring" : "Käyttäjän {user} aikataulu sisältää päivämääräkohtaisia tunteja, mikä ei ole yhteensopivaa toistuvien kokousten kanssa.",
        "incompatible_schedule_with_recurring_calendar" : "Aikataulu sisältää päivämääräkohtaisia tunteja, mikä ei ole yhteensopivaa toistuvien kokousten kanssa.",
        "recurring_meetings_enabled_multi_user" : "Toistuvat kokoukset edellyttävät vain yhtä tiimin jäsentä, eikä hänen aikatauluunsa saa sisältyä päivämääräkohtaisia tunteja.",
        "weekdays" : "Arkipäivisin, {timeRange}",
        "weekdays_hours_vary" : "Arkipäivisin, kellonajat vaihtelevat",
        "weekend" : "Viikonloppuna, {timeRange}",
        "weekend_hours_vary" : "Viikonloppuna, tunnit vaihtelevat",
        "days_hours_vary" : "{days}, tunnit vaihtelevat",
        "date_specific_hours_tab_name" : "Päivämääräkohtaiset tunnit",
        "date_specific_hours" : "{count} päivämääräkohtaista tuntia",
        "date_specific_hours_1" : "1 päivämääräkohtainen tunti",
        "weekly_hours" : "Viikoittaiset tunnit",
        "custom_schedule" : "Mukautettu aikataulu",
        "select_schedule" : "Valitse aikataulu",
        "no_schedules_found" : "Aikatauluja ei löytynyt",
        "untitled" : "Nimetön",
        "error_updating_schedules" : "Virhe aikataulujen päivittämisessä",
        "daily" : "Päivittäinen",
        "weekly" : "Viikoittainen",
        "monthly" : "Kuukausittainen",
        "custom" : "Mukautettu",
        "this_is_required" : "Tämä on pakollinen",
        "search" : "Haku",
        "edit_hours" : "Muokkaa tunteja",
        "schedule_name_duplicate" : "Samanniminen aikataulu on jo olemassa",
        "delete_schedule_title" : "Poistetaanko aikataulu {scheduleName}?",
        "delete_schedule_description" : "Tätä toimintoa ei voi kumota. Oletko varma, että haluat jatkaa?",
        "delete_schedule_negative_text" : "Peruuta",
        "delete_schedule_positive_text" : "Kyllä, poista",
        "active_on" : "Aktiivinen käytössä",
        "weekly_working_hours" : "Viikoittaiset työajat",
        "weekly_working_hours_subtext" : "Valitse päivät ja ajat, jolloin työskentelet",
        "copy_availability_hour" : "Kopioi saatavuustunti",
        "mins" : "Minuutit",
        "hours" : "Tunnit"
      }
    },
    "connections" : {
      "connections" : "Yhteydet",
      "connect" : "yhdistä",
      "conferencing" : "Osallistua neuvotteluun",
      "my_connections" : "Omat yhteydet",
      "account_connections" : "Tili",
      "connection_preferences" : "Yhteys Asetukset",
      "manage_calendars_conferencing_channels" : "Hallinnoida kalentereita ja Osallistua neuvotteluun",
      "main_integration_calendar" : "ENSISIJAINEN Integrointikalenteri",
      "event_integration_calendar" : "tapahtumat Luotu Päällä a järjestelmän kalenteri, johon Sinä/Te ovat osana - tulee myös olemaan Luotu Päällä tämä integroitu kalenteri",
      "2way_sync" : "2-suuntainen Synkronointi: Luoda Järjestelmän tapahtumat - tapahtumat varattu Päällä ENSISIJAINEN integroitu kalenteri",
      "calendars" : "Kalenterit",
      "google" : "Google",
      "outlook" : "Outlook",
      "check_for_conflicts" : "Conflicts-merkki",
      "choose_accounts_to_connect" : "Valita, johon Tili Sinä/Te haluat yhdistää",
      "payments" : "Maksut",
      "stripe" : "Stripe",
      "ads" : "Mainokset",
      "local_service_ads" : "Paikallisen palvelun Mainokset",
      "fire_workflow" : "Fire Työnkulku Tapahtumat-käynnistimet varattu Kautta 2-suuntainen Synkronointi",
      "connect_google_outlook" : "Yhdistä Google/Outlook/iCloud Tili, jotta voit valita Valita ENSISIJAINEN kalenterin.",
      "execute_automation" : "Suorita automaatio",
      "save" : "Arkistoida",
      "lsa" : "Paikallisen palvelun Mainokset",
      "no_write_access" : "Sinä/Te älä kirjoita Pääsy tähän kalenteriin",
      "connection_remove_confirmation" : "Sinä/Te're - Poimiaan tässä Integrointissa",
      "active" : "Dynaaminen",
      "icloud" : {
        "title" : "iCloud Integrointi",
        "description" : "Kaksivaiheinen todennus ja sovelluskohtainen password ovat Pakollisia Tilin yhdistämiseen.",
        "email" : "iCloud -sähköpostiosoite",
        "password" : "iCloud-salasana",
        "connect" : "Yhdistä",
        "cancel" : "Peruuttaa"
      }
    }
  },
  "appointment_modal" : {
    "select_a_contact" : "Valita Kontakti",
    "start_time" : "Alkamispäivämäärä",
    "unassigned" : "Määrittämätön",
    "end_time" : "Loppupäivämäärä",
    "search_by_name_email_phone_or_company" : "Hakea Kautta nimi, Sähköposti, Puhelin Tai Yritys",
    "add_new" : "Lisätä uusi",
    "pick_from_available_contacts" : "Tai Valita - saatavilla Kaveri",
    "book_appointment" : "Varata Tapaaminen",
    "add_blocked_off_time" : "Lisätä Estetty Poistettuaan päivämäärä",
    "recommended_timezones" : "Suositeltu aikavyöhykkeet",
    "all_timezones" : "aikavyöhykkeet",
    "calendar" : "Kalenteri",
    "repeat" : "Toisto",
    "date_and_time" : "Päivämäärä ja päivämäärä",
    "close" : "Sulkea",
    "team_member" : "Ryhmä Jäsenet",
    "recurring_booking" : "Toistuva varaus",
    "one_slot_booking" : "Yksi aikaväli Varaus",
    "event_type" : "Tapahtuman tyyppi",
    "occurrences_booked" : "tapahtumat varataan",
    "repeats" : "Toistot",
    "booking_details" : "Yksityiskohdat",
    "showing_slots_in_this_timezone" : "Esittely-aikataulut in aikavyöhykkeellä:",
    "update_contact_tz" : "Päivitä myös Kontakti aikavyöhyke seuraavaksi:",
    "date" : "Päivämäärä",
    "slot" : "aikaväli",
    "calendar_default" : "Kalenterin Oletus",
    "custom" : "Mukautettu",
    "meeting_notes" : "(esim.) Osallistua neuvotteluun muistiinpanoja tulevaan Tapaaminenmme",
    "out_of_office" : "(esim.) - toimisto Viikko!",
    "standard" : "Oletus",
    "appointment_title" : "Tapaaminen Otsikko",
    "event_title" : "Tapahtuma Otsikko",
    "appt_with_bob" : "(esim.) Tapaaminen Pentin kanssa",
    "vacation" : "(esim.) Loma",
    "show_notes" : "Näyttää muistiinpanot",
    "hide_notes" : "Piilottaa muistiinpanot",
    "additional_preferences" : "Lisäasetukset",
    "meeting_location" : "Osallistua neuvotteluunin sijainti",
    "appointment_status" : "Tapaaminen Tila",
    "appt_description" : "Tapaaminen Kuvaus",
    "recurring_details" : "Toistuva Yksityiskohdat",
    "event_description" : "Tapahtuma Kuvaus",
    "in_contact_timezone" : "Kontaktin in",
    "vacation_message" : "Aiotko lomailla Päällä? Take some Päivämäärä Poistettuna? Estä kalenterisi Estä Poistettu päivämäärä Päällä - varaus Tapaaminen Tämänhetkinen Tapaaminen pysyy silti Päällä kalenterisi).",
    "contact" : "Kontakti",
    "delete" : "Poista",
    "cancel" : "Peruuttaa",
    "back" : "Takaisin",
    "pick_available_contacts" : "Tai Valita - saatavilla Kaveri",
    "no_contacts_found" : "Ei Kaveri löytöä",
    "found" : "löydetty",
    "select_one" : "Valita yksi",
    "tz_tooltip" : "Tällä on vain merkitystä Jos Sinä/Te're Kautta Mukautetut arvot; kuten Tapaaminen Tapaaminen Tapaaminen tms.. Lähtevä in Asiakas Tai asiakkaillasi. Ja yksinkertaisesti se muuttaa edellä mainitut Yksityiskohdat paikallisiksi Päivämääräiksi.",
    "meeting_location_tooltip" : "Osallistua neuvotteluun-paikkana on Kokoelma kalenterin in .",
    "appt_meeting_location_tooltip" : "Käyttäjät voivat Kokoelma Tapaaminen-kohtaisen Osallistua neuvotteluun sijainnin.",
    "gmeet_tooltip" : "Luoda, että kunkin Ryhmä Jäsenetillä on ENSISIJAINEN kalenterinaan Google Calendar Kokoelma",
    "zoom_tooltip" : "Luoda, että kyseisessä Ryhmä Jäsenetissä on Zoom integroitu",
    "enter_meeting_location" : "Kirjoita Osallistua neuvotteluun sijainti",
    "save_appointment" : "Arkistoida Tapaaminen",
    "save_event" : "Arkistoida Tapahtuma",
    "search_contacts" : "Hakea Kautta nimi, Sähköposti, Puhelin Tai Yritys",
    "recurring_slots" : "{recurringSlotsLength}/{count}",
    "custom_timezone" : "Mukautettu aikavyöhyke",
    "system_timezone" : "Järjestelmä aikavyöhyke",
    "contact_timezone" : "Kontakti aikavyöhyke",
    "account_timezone" : "Tili aikavyöhyke",
    "an_error_occurred" : "Tapahtui virhe"
  },
  "popup" : {
    "calendar" : "Kalenteri",
    "appointment_owner" : "Tapaaminen Omistaja",
    "source" : "Lähde",
    "booked_by" : "Varattu Kautta",
    "view_activity_log" : "Katsoa Toimintaloki",
    "status" : "Tila",
    "cancel_appointment" : "Peruuttaa Tapaaminen",
    "cancel_all" : "Peruuttaa enemmän",
    "google_event" : "Google Tapahtuma",
    "outlook_event" : "Outlook- Tapahtuma",
    "blocked_slot" : "Estetty aikaväli",
    "appointment" : "Tapaaminen",
    "confirmed" : "Vahvistettu",
    "unconfirmed" : "Vahvistamaton",
    "cancelled" : "Peruutettu",
    "showed" : "Osallistunut",
    "no_show" : "Ilmestymätön jääminen",
    "invalid" : "Virheellinen",
    "more" : "Lisää",
    "less" : "Vähemmän",
    "edit" : "Muokata",
    "reschedule_all" : "Siirtää ääni",
    "guests" : "Vieras(vieraat)",
    "guest_count" : "Vieras(s) Lukumäärä"
  },
  "create_calendar" : {
    "calendar_name" : "Kalenterin nimi",
    "calendar_logo" : "Kalenterin Logo",
    "select_team_member" : "Valita Ryhmä Jäsenet",
    "select_single_team_member" : "Valitse tiimin jäsen",
    "eg_outbound_reach" : "(esim.) Lähtevä kattavuus",
    "description" : "Kuvaus",
    "amount" : "Määrä",
    "description_placeholder" : "Kirjoita Kuvaus",
    "meeting_duration" : "Osallistua neuvotteluun Kesto",
    "meeting_location" : "Tapaamispaikka",
    "seats_per_class" : "Paikat per Luokka",
    "group" : "Ryhmä",
    "custom_url" : "Mukautettu URL-osoite",
    "meeting_invite_title" : "Osallistua neuvotteluun kutsu Otsikko",
    "event_color" : "Tapahtuma Väri",
    "availability_type" : "Tuote Kirjoittaa",
    "new_calendar" : "uusi kalenteri",
    "add_description" : "Lisätä Kuvaus",
    "remove_description" : "Poimia Kuvaus",
    "booking_availability" : "Varauksen saatavuus",
    "slug_tooltip" : "Mukauttaa Ajanvaraus-widget URL",
    "meeting_location_tooltip" : "Osallistua neuvotteluun Linkit ovat Osallistunut in tapahtumat-issa \"Osallistua neuvotteluun\"-paikkana ja Ottaa käyttööninä/Te to Sisällyttää asioita Tykätä zoom-linkit tapahtumaan.",
    "advanced_settings" : "Asetukset",
    "show_more_schedule" : "Näytä lisää",
    "show_more_helper_text" : "Jos haluat mukauttaa aukioloaikoja tarkemmin, siirry lisäasetuksiin",
    "reschedule_preference" : "Siirrä Valinta Siirtää",
    "reschedule_preference_subtext" : "Jos {contactLabel} siirtää tapaamista:",
    "reassign_through_round_robin" : "Määritä Kautta Round Robin uudelleen",
    "keep_same_assinged_user" : "Ota sama Tapaaminen Omistaja",
    "new_appointment_preference" : "uusi Tapaaminen Valinta",
    "new_appointment_preference_text" : "Tee varaus aina kontaktin {contactLabel} määrittämän käyttäjän kanssa",
    "new_appointment_preference_subtext" : "Varaa uusia tapaamisia kontaktin {contactLabel} määrittämän käyttäjän kanssa vuorottelevan Round Robin ‑aikataulutuksen sijaan.",
    "cancel" : "Peruuttaa",
    "confirm" : "Vahvista",
    "service_calendar_name" : "Palvelun nimi",
    "service_logo" : "Palvelun Logo",
    "service_select_team_member" : "Valita Staff Jäsenet",
    "service_duration" : "Palvelu Kesto",
    "appointment_invite_title" : "Tapaaminen kutsu Otsikko",
    "payment_placeholder" : "Syötä Kuvaus, joka näytetään Käyttäjille ja ilmoitetaan - maksu",
    "deposit_amount" : "Talletusmäärä",
    "collect_deposit_amount" : "Hyväksy Keskeneräinen-maksu",
    "percentage" : "Prosenttiosuus",
    "total_amount" : "Yhteensä",
    "enter_meeting_location" : "Lisää tapaamispaikka",
    "accept_payments" : "Hyväksy maksut",
    "aria" : {
      "should_accept_payment" : "Maksu tulisi hyväksyä"
    },
    "calendar_name_tooltip" : "Kalenterin nimi näytettäväksi Päällä Ajanvaraus-widget",
    "booking_availability_tooltip" : "Kokoelma päivät ja tunti, jolle varauksia voi tehdä. Nämä ovat Oletus Viikoittainen Yritys tunti Osallistunut to Käyttäjä Kun valitset Aikaikkunan",
    "select_team_member_tooltip" : "Valita Ryhmä Jäsenet(e), jotka olisivat vastaanottamassa tähän Osallistua neuvotteluun",
    "seats_per_class_tooltip" : "Kokoelma the Maksimi luku - Jäsenet sallittu Varatalle tämä Luokka. Kun Paikaikat on täytetty, Aikaikkuna ei ole enää varattavissa",
    "meeting_color" : "Osallistua neuvotteluun Väri",
    "meeting_duration_tooltip" : "Tämä Kiinteä the Pituus - Osallistua neuvotteluun, joka määrittää, kuinka kauan se viimeisin"
  },
  "calendar_advanced" : {
    "general" : {
      "quick_tip" : "Pikavinkki",
      "timezone_change_tip" : "Päivämäärävyöhykkeet voivat olla Dynaaminen milloin tahansa Päivämäärävyöhyke Asetukset -kohdassa",
      "save" : "Arkistoida",
      "close" : "Sulkea",
      "meeting_details" : "Osallistua neuvotteluun yksityiskohdat",
      "availability" : "Saatavuus",
      "forms_and_payment" : "Lomakkeet ja maksut",
      "notifications_and_additional_options" : "Muistutus & Lisä Vallinnat",
      "connections" : "Yhteydet",
      "customizations" : "Räätälöinnit",
      "create" : "Luoda",
      "edit" : "Muokata",
      "equipments" : "Huone & Laitteet",
      "service_details" : "Palvelun Yksityiskohdat",
      "saving_changes" : "Vain hetkinen — Tallennetaan uusin Dynaaminen...",
      "calendar_id": "Kalenteritunnus",
      "saveCalendarSuccess": "Kalenteri tallennettu onnistuneesti"
    },
    "meeting_details" : {
      "meeting_location" : "Osallistua neuvotteluunin sijainti",
      "enter_meeting_location" : "Kirjoita Osallistua neuvotteluun sijainti",
      "click_to_upload" : "napsauttaa Ladataan",
      "square" : "Neliö",
      "circle" : "Ympyrä",
      "remove_logo" : "Poimia Logo",
      "meeting_invite_title_tooltip" : "Tämä on kalenterin Otsikko Osallistua neuvotteluun, joka osallistuu Tapaamiset in , kalenterin Katsoa- ja Kolmannen osapuolen kalenterit",
      "event_color_tooltip" : "Valita a Väri tälle varaukselle Tapahtuma. Värit synkronoidaan tapahtumiin in Google .",
      "enter_a_name" : "Kirjoita nimi",
      "enter_an_event_title" : "Kirjoita Tapahtuma Otsikko",
      "high_priority" : "Korkea Prioriteetti",
      "medium_priority" : "Keskikokoinen Prioriteetti",
      "low_priority" : "Alhainen Prioriteetti",
      "priority" : "Prioriteetti",
      "custom" : "Mukautettu",
      "zoom_not_added" : "Käyttäjä ei ole vielä yhdistänyt Zoom Tiliään",
      "opt_avail" : "Optimoi tulokselle",
      "opt_equal" : "Optimoi samalle Toimitukselle",
      "team_members" : "Valita Ryhmä Jäsenet",
      "team_members_location" : "Valita Ryhmä Jäsenet & Assign Osallistua neuvotteluun sijainti",
      "team_member" : "Valita Ryhmä Jäsenet",
      "team_member_location" : "Valita Ryhmä Jäsenet & Assign Osallistua neuvotteluun sijainti",
      "meeting_location_required" : "Osallistua neuvotteluunin sijainti on Pakollinen",
      "meeting_details" : "Osallistua neuvotteluun yksityiskohdat",
      "meeting_details_description" : "Nämä ovat yksityiskohdat, jotka osallistuvat in Luettelo Sivulla.",
      "or_drag_and_drop" : "Tai Vetää ja pudota",
      "service_details" : "Palvelun Yksityiskohdat",
      "team_member_disabled_recurring_tooltip" : "Toistuva-kokoukset Ottaa käyttöön vain yhden Ryhmä Jäsenet. Jos haluat Sisällyttää useita Ryhmä Jäsenet, poistaa Toistuva-kokoukset.",
      "team_member_disabled_class_booking_tooltip" : "Luokka Palvelukalenteriin voidaan lisätä vain yksi Ryhmä Jäsenet",
      "advanced_settings" : "Asetukset",
      "enable_contact_assigned_to_setting" : "Jos haluat ottaa tämän Asetuksen käyttöön, Lomakkeen on oltava in Widget Järjestää. Siirtää Widget Järjestää - Lomakkeet ja maksut -välilehti.",
      "reschedule_preference_setting_tooltip" : "Valitse ajanvaraus-widgetistä, kenelle tapaaminen osoitetaan, kun {contactLabel} siirtää tapaamista.",
      "appointment_preference_tooltip" : "Valitse, tuleeko uudet tapaamiset varata aina kontaktin {contactLabel} määrittämän käyttäjän kautta. Jos {contactLabel} on määrittänyt käyttäjän, kyseiselle käyttäjälle annetaan etusija; muussa tapauksessa sovelletaan vuoropohjaista Round Robin ‑määritystä. Vinkki: Poista käytöstä \"Salli henkilökunnan valinta\", jos haluat estää varaajia vaihtamasta henkilökunnan jäsentä ajanvaraus-widgetissä.",
      "add_location" : "Lisätä Sijainti",
      "multiple_locations_neo" : "Useita Osallistua neuvotteluun Osoite tuetaan vain Kautta the Neo Widget.",
      "make_owner" : "Luoda Omistaja",
      "only_one_team_member" : "Vain yksi Ryhmä Jäsenet on sallittu Kun useita Osoiteita lisätään.",
      "ask_the_booker_error_message" : "Kysy Buukkaajasta Sijainti on jo olemassa",
      "enter_location" : "Anna Sijainti Arvo",
      "enter_display_label" : "Anna Näyttö- tunniste",
      "add_display_label" : "Lisätä Näyttö- tunniste",
      "multiple_location_support_message" : "Useita Osallistua neuvotteluun Osoite tuetaan vain Kautta the Neo Widget.",
      "only_one_team_member_personal_calendar" : "Vain yksi Ryhmä Jäsenet on henkilökohtainen varaus ",
      "ms_teams_not_added" : "Käyttäjä ei ole vielä yhdistänyt Microsoft Ryhmä Tiliään",
      "enable_new_appt_preference" : "Valinta uusi Tapaaminen Ottaa käyttöön",
      "enable_new_appt_preference_desc" : "Jos otat käyttöön asetuksen &quot;<b>Varaa aina kontaktin {contactLabel} määrittämän käyttäjän kanssa</b>&quot;, <b>lomake</b> asetetaan automaattisesti widget-tilauksen ensimmäiseksi vaiheeksi.",
      "location_exists_toast" : "Osallistua neuvotteluun Sijaintia on jo lisätty",
      "not_supported_with_multiple_team_members" : "Ei tueta useiden ryhmäJänettien kanssa",
      "not_supported_personal_calendar" : "Ei tueta in kalenterissa",
      "not_supported_class_booking" : "Ei in Luokka Palvelukalenterissa",
      "not_supported_collective_booking" : "Ei tueta KOLLEKTIIVINEN in",
      "not_supported_service_booking" : "Ei tueta in",
      "not_supported_round_robin" : "in Round Robin Ei tueta",
      "not_supported_event" : "Ei tueta in",
      "calendar_logo_tooltip" : "Valita a Logo on Osallistuanut Päällä Ajanvaraus-widget",
      "calendar_name_tooltip" : "Kalenterin nimi näytettäväksi Päällä Ajanvaraus-widget",
      "description_tooltip" : "Kuvaile mikä kalenteri on -, näytettäväksi Päällä Ajanvaraus-widget",
      "group_tooltip" : "Sinä/Te voi määrittää tämän kalenterin Ryhmälle (Jos Luotu). Käyttäjät Pääsy -ryhmän Linkki voivat selata ja Varata in kalentereita",
      "custom_url_tooltip" : "Mukauttaa Ajanvaraus-widget URL",
      "meeting_color_tooltip" : "Valita a Väri tälle varaukselle Tapahtuma. Värit saavat Synkronoinnin Tapahtumiin in Google",
      "add_display_label_tooltip" : "Jos sijainnin voi peittää, Sijainti Vallinnat on saatavilla useita",
      "meeting_location_tooltip" : "Valita miten Tai missä Osallistua neuvotteluun ottaa Sijainti",
      "team_members_location_tooltip" : "Valita the Ryhmä Jäsenet, joka olisi ottanut tämän Osallistua neuvotteluun",
      "meeting_distribution" : "Osallistua neuvotteluun Toimitus",
      "meeting_distribution_tooltip" : "Valita how Tapaamiset ovat jakautuneet Valittu Ryhmä Jäsenet — perustuva Päällä tulee Tai equal Toimitus",
      "opt_avail_tooltip" : "Määritä tapaamiset Ryhmä Jäsenetille, joka on tavoitettavissa Valittu Päivämäärällä - Edellinen varauksista huolimatta. Maksimoi Avata aikavälin käytön ja varauksen Onnistuminen Esiintymistaajuus",
      "opt_equal_tooltip" : "Julkaista tapaamiset Tasaisesti joukossa Ryhmä Jäsenet Kautta seuranta Edellinen varaus. Priorisoi oikeudenmukaisuus ennen tuotetta",
      "priority_tooltip" : "Kokoelma the Valinta Tasainen tapaamisten määrittämiseen Kun useita Ryhmä Jäsenet ovat saatavilla. Korkeampi Prioriteetti Jäsenet huomioidaan ensimmäisenä varauksissa, Seurata Kautta Keskikokoinen ja matala Prioriteetti Jäsenet",
      "contact_routing_preference" : "Kontakti Valinta",
      "contact_routing_preference_tooltip" : "Määritä, miten uudet ja palaavat {contactsLabel} liitetään tiimin jäseniin – joko Round Robin ‑vuorottelun tai alkuperäisen omistajan perusteella",
      "team_members_location_owner_tooltip" : "ENSISIJAINEN Käyttäjä, joka omistaa Osallistua neuvotteluun ja tarjoaa lopullisen Osallistua neuvotteluun sijainnin",
      "owner" : "Omistaja",
      "upload_from_system" : "Lataa järjestelmästä",
      "choose_from_media_storage" : "Valitse mediatallennustilasta",
      "only_one_team_member_allowed" : "Vain yksi ryhmän jäsen on sallittu",
      "at_least_two_team_members_required" : "Vähintään kaksi tiimin jäsentä vaaditaan",
      "at_least_one_team_member_required" : "Tiimin jäseniä on oltava vähintään yksi"
    },
    "availability" : {
      "my_availability" : "Oma malli",
      "set_availability" : "Kokoelma kalenterisi tässä.",
      "standard" : "Vakio-",
      "custom" : "Mukautettu",
      "to" : "Vastaanottaja",
      "copy_to_all" : "Kopioida to usealle",
      "add_time" : "Lisätä päivämäärä",
      "recurring_meeting" : "Toistuva osallistua neuvotteluun",
      "recurring_info" : "Vain yksi käyttäjä per kalenteri Toistuva-varaukselle",
      "repeat" : "Toisto",
      "times_to_repeat" : "kertaa Toistolle",
      "slots_unavailable" : "Jos aikaväliä ei ole saatavilla?",
      "overlap_status" : "Tapaaminen Tila päällekkäisille aikaväleille ",
      "meeting_interval" : "Kokousväli",
      "meeting_duration" : "Osallistua neuvotteluun Kesto",
      "minimum_scheduling" : "Minimi- Ajoittaa ILMOITUS",
      "date_range" : "Päivämäärä Laajuus",
      "maximum_bookings_per_day" : "Maksimi-varaukset per päivä",
      "maximum_bookings_per_slot" : "Maksimi-varaukset per aikaväli",
      "maximum_bookings_per_slot_per_user" : "Maksimi varauksia per aikaväli (per käyttäjä)",
      "seats_per_class" : "Paikat per Luokka",
      "pre_buffer_time" : "Pre PUSKURI Päivämäärä",
      "post_buffer_time" : "Jakaa PUSKURI Päivämäärä",
      "pre_buffer_tooltip" : "Esipuskuri on ylimääräinen päivämäärä, joka voidaan lisätä Ennen tapaamista, Ottaa käyttöön ylimääräistä päivämäärää saadakseen",
      "post_buffer_tooltip" : "Jälkipuskuri on ylimääräinen päivämäärä, joka voidaan lisätä Jälkeen an Tapaaminen, Ottaa käyttöön ylimääräistä päivämäärää varten",
      "buffer_time" : "PUSKURI Päivämäärä",
      "daily" : "Päivittäinen",
      "weekly" : "Viikoittainen",
      "monthly" : "Kuukausitttainen",
      "skip_booking" : "Ohita ei-käytettävissä olevien aikavälien varaus",
      "continue_booking" : "Jatkaa varausta",
      "book_next_available" : "Varata Seuraava saatavilla aikaväli",
      "confirmed" : "Vahvistettu",
      "unconfirmed" : "Vahvistamaton",
      "enter_valid_hours" : "Anna hyväksyttävä Avata tunti",
      "enter_valid_avail" : "Anna hyväksyttävä määrä Mukautettu tuote",
      "availability_type_tooltip" : "Valita Vakio-tulos tarjolla Kuukausitttaisten varauksiin Viikoittainen. Valita Mukautettu varauksiin saatavilla vain Päällä tiettyinä päivinä.",
      "meeting_interval_tooltip" : "Osallistua neuvotteluun Sekunnit kuvastaa in ilmoittautuvien varausvälien välistä summaa - Päivämäärää. 30 Minimi- Tapahtumaan, jonka pitäisi olla saatavilla Ylä-; Ylin -tunti, Sekunnit olisi 1 h. 30 Minimi-tapahtuman, jonka pitäisi olla käytettävissä enintään 30 minuuttia, Sekunnit olisi 30 minuuttia.",
      "date_range_tooltip" : "tapahtumat voidaan Ajoitettu Seuraavan n päivän aikana.",
      "maximum_bookings_per_day_tooltip" : "Maksimi luku - kokoukset sallittu per kalenterin Päivä Päällä",
      "maximum_bookings_per_slot_tooltip" : "Maksimi luku - Tapaaminen sallittu per aikaväli Käyttäjälle, Sitten it Tai vaihtaa Round Robin in Seuraavaan käyttäjään Tai Vesileima Aikaväli, joka ei ole käytettävissä Mahdollisuudelta Varataan) .",
      "add_days" : "Lisätä päivät",
      "month_on_day" : "Kuukausitttainen Päällä päivä",
      "month_on_last_day" : "Kuukausitttainen Päällä viimeisin",
      "day" : "Päivä",
      "week" : "Viikko",
      "month" : "Kuukausi",
      "mins" : "Minuutit",
      "hours" : "Tunnit",
      "days" : "päivää",
      "weeks" : "Viikot",
      "months" : "Kuukaudet",
      "meeting_interval_error" : "Osallistua neuvotteluun Sekunnitin on oltava 5 minuutin ja 12 tunnin välillä",
      "meeting_duration_error" : "Osallistua neuvotteluun Keston on oltava 1 Minimi- 12 tuntin välillä",
      "buffer_time_error" : "PUSKURI Päivämäärän on oltava pienempi kuin 12 tunti",
      "appointment_interval" : "Tapaaminen Sekunnit",
      "appointment_duration" : "Tapaaminen Kesto",
      "maximum_appointments_per_day" : "Maksimi Tapaaminen per päivä",
      "subTitle" : "Valitse Päivämäärä – Kokoelmakohtainen tunti",
      "heading_1" : "Viikoittainen Saatavilla oleva tunnit",
      "scheduling_availability_heading" : "Varausten saatavuus",
      "tooltip_1" : "Kokoelma sinun Viikoittainen tulee aikataulu. Nämä ovat sinun Vakio-tuntisi, joita sovelletaan johdonmukaisesti Päällä a Viikoittainen-pohjalta",
      "heading_2" : "Kun ovatko Sinä/Te saatavilla?",
      "unavailable_label" : "Ei saatavilla",
      "tooltip_2" : "Muokata suunnitelmasi tietyille päivämäärille. Ohita Kuukausitttainen Viikoen tunti Kautta marking Tuleittain Tai ei ole saatavilla Valittu-päivämäärille.",
      "date_specific_level" : "Lisätä Päivämäärä tietty tunti",
      "specific_hours_button" : "Päivämäärä tunnit",
      "specific_hours_description" : "Ohita saatavuutesi tiettyinä päivinä, joina tuntisi poikkeavat tavallisista viikoittaisista tunneistasi.",
      "overlap_error" : "Päivämäärä-aikaa ei voi PÄÄLLEKKÄISYYS",
      "apply" : "Käyttää",
      "copy_times_to" : "Kopioida kertaa kohteeseen",
      "no_date_specific_heading" : "Ei Päivämäärää tietty päivämäärä lisätty",
      "no_date_specific_description" : "Sinä/Te voi Sisällyttää/Poimia-kohtaiset Päivämäärät ja Päivämäärät omaan tuotteesi",
      "recurring_disabled_conditions_tooltip" : "Toistuva-kokoukset ovat Poistettua. Heidän käynnistääkseen tulee varmistaa, että kalenterissa on vain yksi Ryhmä Jäsenet eikä siihen ole lisätty päivämääräkohtaista tunti Tai Keskeneräinen-maksua.",
      "date_specific_hours_disabled_conditions_tooltip" : "Jos haluat Sisällyttää päivämääräkohtaisen tunnin, varmista, että Toistuva-kokoukset käännetään Poistettuna.",
      "recurring_disable_event_calendar_conditions" : "Toistuva-kokoukset ovat Poistettua. Aloitakseen heille ei ole lisätty päivämääräkohtaista tunti Tai Keskeneräinen maksua.",
      "service_duration" : "Palvelu Kesto",
      "service_interval" : "Palvelu Sekunnit",
      "service_interval_tooltip" : "Osallistua neuvotteluun Sekunnit Kiinteä kuinka usein varausajat näkyvät Päällä kalenterissa. Mallille 30 minuutin mittaisen tapahtuman 1 tunti Sekunnit tarkoittaa lopputuntia.A 30 minuutin Sekunnit tarkoittaa lopputuntia.",
      "service_duration_tooltip" : "Tämä Kiinteä the Pituus - Tapaaminensi, määrität, kuinka kauan se viimeisin.",
      "minimum_scheduling_tooltip" : "Tämä Kiinteä the Minimi- Päivämäärä Pakollinen to Varata an Tapaaminen Kautta kalenteri- Widget. Mallille Jos Kokoelma - 4 tunti, Tapaaminen ei ole varattavissa 4 tunnin sisällä - niiden alkamispäivämäärä; varaukset tulee tehdä vähintään 4 tuntia in .",
      "look_busy_title" : "Look Busy",
      "look_busy_helper_text" : "Piilottaa a Prosenttiosuus - käytettävissä olevat Tapaaminen-aikasi Päällä Ajanvaraus-widget näyttääksesi aktiivisemmalta ja in",
      "look_busy_percentage_description" : "Piilottaa the luku - vapaata aikaväliä Kautta x%",
      "maximum_bookings_per_slot_tooltip_personal" : "Rajoita, kuinka monta kokousta voidaan Ajoitettu samalla Aikaikkunalla",
      "enable_recurring_title" : "Ottaa käyttöön Toistuva osallistua neuvotteluun",
      "enable_recurring_desc" : "Päällä <b>Toistuva Meetingsin</b> kääntäminen poistaa automaattisesti Perässä olevat Asetukset, sillä ne eivät voi olla rinnakkain:",
      "date_specific_hours" : "<b>Päivämääräkohtaiset tunnit</b> ovat Poistettu.",
      "multiple_team_members" : "<b>Useat Ryhmä Jäsenet</b> ovat Tilaus peruutettu — vain yksi Ryhmä Jäsenet voi olla jäljellä in kalenterissa.",
      "partial_payments" : "<b>Keskeneräinen Maksut</b> on Poistettua ja peritään Täysi-summa.",
      "select_team_member_to_keep" : "Valita a Ryhmä Jäsenet to Pitää in kalenterissa:",
      "select_team_member" : "Valita Ryhmä Jäsenet",
      "partial_payments_disabled" : "Koska Keskeneräinen Payments on Poistettuna, miten Sinä/Te Tykätä periisi Täysi-summan Toistuva Tapauksesta?",
      "enable_date_specific_hours" : "Ottaa käyttöön Päivämäärä tunnit käyttöön",
      "enable_date_specific_hours_desc" : "Päällä <b>päivämääräkohtaisten tuntien</b> kääntäminen poistaa Perässä olevan Asetuksen automaattisesti, sillä ne eivät voi olla rinnakkain:",
      "recurring_meetings_disabled" : "<b>Toistuvat kokoukset poistetaan käytöstä</b>; {contactsLabel} voi varata vain yksittäisiä tapaamisia asettamiesi saatavilla olevien päivämäärien perusteella.",
      "payment_preference" : "Valinta:",
      "team_members_in_this_calendar" : "Ryhmä Jäsenet in kalenterissa",
      "other_team_members" : "Muu Ryhmä Jäsenet (ei lisätty tähän kalenteriin)",
      "select_team_member_tooltip" : "Valita Ryhmä Jäsenet(e), jotka olisivat vastaanottamassa tähän Osallistua neuvotteluun",
      "meeting_duration_tooltip" : "Tämä Kiinteä the Pituus - Osallistua neuvotteluun, joka määrittää, kuinka kauan se viimeisin",
      "date_specific_hours_tooltip" : "Muokata suunnitelmasi tietyille päivämäärille. Ohita Kuukausitttainen Viikoen tunti Kautta marking Tuleittain Tai ei saatavuus Valittu-päivämäärille",
      "recurring_meeting_tooltip" : "Ottaa käyttöön tapaamisia Toistoon useita kertoja Viikon yli",
      "repeat_frequency_tooltip" : "Valita Esiintymistaajuus - tämä Toistuva tapahtuma",
      "time_to_repeat_tooltip" : "Kokoelma the yhteensä luku - Toistot",
      "slots_unavailable_tooltip" : "Valita mitä tapahtuu Jos yksi Tai useampi Päivämäärä Toistuva- in on jo varattu",
      "skip_booking_tooltip" : "Vain vapaat aikavälit varataan. Mahdolliset puuttuvat päivämäärät Toistuva- in ovat ohitettuja",
      "force_book" : "Pakota Varata",
      "force_booking_tooltip" : "pääsy-aikaa on varattu, Tasainen Jos on Konflikti. Käytä Varituksen kanssa välttääksesi Päällekkäiset varaukset",
      "book_next_available_tooltip" : "Jos a Valittu aikaväli ei ole saatavilla, Varata Seuraava saatavilla oleva aikaväli Päällä samassa Toistuva aikataulu (esim. Seuraava Maanantai Jos Viikoittainen)",
      "slot_interval_tooltip" : "Kokoelma kuilu aloitus kerran - peräkkäisenä vapaana aikavälillä. Mallilla Jos osallistua neuvotteluun Kesto on 30 minuuttia ja Sinä/Te Kokoelma Sekunnit 60 minuuttia, Käyttäjä voi Varata klo AM, Sitten AM 10.00, joten Päällä — Tasainen tosin Osallistua neuvotteluun kestää vain 30. minuuttia",
      "minimum_scheduling_notice_tooltip" : "Pakollinen käyttäjä Varata-kokouksille vähintään tämän verran Päivämäärää in",
      "date_range_preferences_tooltip" : "Kokoelma kuinka pitkälle tulevaisuuteen voidaan tehdä varauksia - Tämän päivän Päivämäärä",
      "maximum_bookings_per_slot_preferences_tooltip" : "Rajoita, kuinka monta kokousta voidaan Ajoitettu samalla Aikaikkunalla",
      "maximum_bookings_per_slot_per_user_preferences_tooltip" : "Rajoita, kuinka monta kokousta voidaan Ajoitettu samalle Aikaikkunalle (per käyttäjä)",
      "pre_buffer_time_tooltip" : "Päivämäärä to estää ennen osallistua neuvotteluun, Päivämäärä valmistautua",
      "post_buffer_time_tooltip" : "Päivämäärä to block Jälkeen osallistua neuvotteluun, Ottaa käyttöön ylimääräinen Päivämäärä päättyy",
      "seats_per_class_tooltip" : "Kokoelma the Maksimi luku - Jäsenet sallittu Varatalle tämä Luokka. Kun Paikaikat on täytetty, Aikaikkuna ei ole enää varattavissa",
      "maximum_bookings_per_slot_per_user_tooltip" : "Rajoita, kuinka monta kokousta voidaan Ajoitettu samalle Aikaikkunalle (per käyttäjä)",
      "repeat_frequency" : "Esiintymistaajuus Toisto",
      "slot_interval" : "aikaväli Sekunnit",
      "skip_booking_helper_text" : "Vain vapaat aikavälit varataan. Mahdolliset puuttuvat päivämäärät Toistuva- in ovat ohitettuja",
      "force_book_helper_text" : "pääsy-aikaa on varattu, Tasainen Jos on Konflikti. Käytä Varituksen kanssa välttääksesi Päällekkäiset varaukset",
      "book_next_available_helper_text" : "Jos a Valittu aikaväli ei ole saatavilla, Varata Seuraava saatavilla oleva aikaväli Päällä samassa Toistuva aikataulussa (esim. Seuraava Maanantai Jos Viikoittainen).",
      "bulk_edit" : "Massamuokkaus",
      "select_users" : "Valitse käyttäjät",
      "select_all" : "Valitse kaikki",
      "times_to_repeat_tooltip" : "Aseta toistojen kokonaismäärä"
    },
    "forms_payment" : {
      "forms" : "Lomakkeet",
      "forms_sub" : "Kokoelma post-Ajoittaa Lomake Asetukset.",
      "select_form" : "Valita Lomake",
      "enable_same_user_assignment" : "Määritä Kaveri omaan kalenteriinsa Ryhmä Jäsenet katupäivämäärä an Tapaaminen on varattu",
      "sticky_contacts" : "Pre-populate Kentät (Paikallaan pysyvä Kaveri)",
      "confirmation_page" : "Vahvistussivu",
      "default" : "Oletus",
      "redirect_url" : "Uudelleenohjauksen URL-osoite",
      "thank_you" : "Kiitos Sinä/Te Viesti",
      "enter_url" : "Lisää URL-osoite",
      "amount_tab_hidden_label" : "Määrä-välilehden paikkamerkki",
      "percentage_tab_hidden_label" : "Prosenttiosuus-välilehden paikkamerkki",
      "pixel_id" : "Meta Pikselin tunnus (Valinnainen)",
      "auto_confirm" : "Vahvista uusi kalenterikokoukset automaattisesti",
      "configure_payment" : "Määrittää maksut Vallinnat",
      "accept_payments" : "Hyväksy maksut",
      "test" : "Testata",
      "live" : "Suora; live; reaaliaikainen",
      "enable_guests" : "Lisätä vieraita",
      "add_guest_tooltip" : "Lisätä Vieras ottaa käyttöön Vierasi ja sisällyttää useita osallistujia samaan Tapauksiin",
      "add_guest_custom_form_tooltip" : "Tämän vaihtoehdon käyttöönotto Ladataan järjestelmän luoman sähköpostin vieraille, joilla on linkki Mukautettu Lomakeen, kun heidän Tapaaminen on Vahvistettu. Estääksesi Kopioida Gmail, varmista, että erillinen vahvistus Sähköposti ei ole jo Määrittää vieraille. (Tarkistaa tämä Muistutus- in > Vahvistus Ilmoitus)",
      "add_guest_same_form_check" : "Ladata sama Lomake noutopaikalle Yksityiskohtiin Kautta postia vieraille",
      "payment_tooltip" : "Maksu otettaisiin vain ENSISIJAINEN Vieroista, ei vieraista.",
      "default_form" : "Oletus (Etunimi, viimeisin nimi, Sähköposti, Puhelin, Muistiinpanot)",
      "select_form_tooltip" : "Jos Sinä/Te olisi Tykätä keräämään enemmän Yksityisiä kohtia kuin Vakio- Etunimi, viimeisin Nimi, Sähköposti ja Puhelin - ne, jotka Varata Päällä tämän kalenterin, Luoda a Mukautettu Lomake in Sivustot > Lomakkeet > Kehittäjä Sitten Valita Lomake Kautta the Pudotus- (jonkin) ala sivu.",
      "confirmation_page_tooltip" : "Kun joku on tehnyt varauksen, Sinä/Te voi Valita hänelle Mukautettu Viesti Päällä sama Sivu (Oletus) Tai uudelleenohjaa hänet valitsemasi sivulle (Uudelleenohjaus).",
      "add_guest_collect_email" : "Nimi ja sähköpostiosoite",
      "add_guest_count_only" : "Vain Lukumäärä",
      "custom_email_notification" : "Ladata Mukautettu Lomake vieraille",
      "consent_label" : "Suostumus Valintaruutu",
      "consent_input_placeholder" : "Lisätä Suostumus Runko",
      "same_user_assignment_tooltip" : "Jos haluat Ottaa käyttöön tämän Asetuksen, Lomakkeen on oltava ensin Päällä the Widget. Siirtää the Widget to Tila the Lomake käynnistää ensin tämä Asetus.",
      "consent_tooltip" : "Ota tämä vaihtoehto käyttöön, jos haluat sallia kontaktin {contactsLabel} suostumuksen pyytämisen, kun tämä antaa puhelinnumeronsa ajanvarauksen yhteydessä.",
      "stripe_error" : "Enintään kahden desimaalin tarkkuudella (Malli: 25,99)",
      "auto_confirm_service" : "Automaattinen vahvistus uusi Tapaaminen",
      "service_form_message" : "Jos a Kontakti varaa useita Palveluja, he näkevät vain Oletus Loman in",
      "deposit_amount_error" : "Talletuksen määrän on oltava pienempi kuin Yhteensä.",
      "deposit_percentage_error" : "Talletusprosenttiosuuden on oltava pienempi kuin 100 %.",
      "partial_payment_tooltip" : "Ottaa käyttöön Keskeneräinen talletussumman keräysmaksut - Asiakkaiden Tapaaminen-varauksen aikana Työnkulku",
      "partial_payment_enable_error" : "Lisätyn Loppusumman on oltava suurempi kuin 0 Ottaa käyttöön Keskeneräinen-maksuihin.",
      "payment_disable_text_integration" : "Integroi maksu Palveluntarjoaja kohdasta Maksut > Integraatiot aloittaaksesi maksujen vastaanottamisen",
      "payment_disable_text_recurring" : "Hyväksy maksuvaihtoehto ei ole käytettävissä Toistuva-kokouksissa. Poistaa Toistuva to Ottaa käyttöön maksut.",
      "date_and_time_selector" : "Päivämäärän ja päivämäärän valitsin",
      "form_selector" : "Lomake",
      "order_step" : "Vaihe",
      "widget_order_label" : "Widget Järjestää",
      "widget_order_tool_tip" : "Siirtää 'Päivämäärä & päivämäärän valitsin' ja 'Lomake' Järjestää Päällä kalenteri- Widget. Vain Vetää ja tilaa uudelleen Valintasi per .",
      "widget_re_order_tooltip" : "Uudelleenjärjestäminen on mahdollista vain Neo Widget -tyylillä. Vaihda Neo Ottaa käyttöön uudelleentilaukseen.",
      "widget_re_order_disabled_tooltip" : "Voit muuttaa widgetien järjestystä poistamalla käytöstä asetuksen \"Uusi ajanvarausasetus (Varaa aina kontaktin {contactLabel} määrittämän käyttäjän kanssa)\" kohdassa Kokouksen tiedot > Tiimin jäsenet > Lisäasetukset.",
      "payment_description_error" : "Maksimi Merkki SLOTMAX – 1 000 saavutettu",
      "widget_multiple_location_disabled_tooltip" : "Klassinen- Widget ei tue useita Osallistua neuvotteluun Osoite. Poimia mitä tahansa ylimääräistä Osoitetta, jotta voit käyttää Klassinen Widget",
      "recurring_payment_label" : "Toistuva Tapaaminen maksu",
      "enable_payments_for_guests" : "Ottaa käyttöön vierasmaksut käyttöön",
      "guest_payment_description" : "Koska Sinä/Te've Käytössä on \"Lisätä Vieraat\" -vaihtoehto, voi Sinä/Te myös Valita veloitukseen per Vieras Kun -varaus.",
      "charge_per_attendee" : "veloitus per Vieras",
      "charge_per_attendee_description" : "Kertoa summa Yhteensä Kautta luku - osallistujat (mukaan lukien vieraat) Kun perii maksu varauksen yhteydessä.",
      "click_confirm_description" : "Napsauta Tallenna, jotta muutokset tulevat voimaan.",
      "multiply_amount_guests" : "Peri maksu osallistujilta",
      "multiply_amount_guests_description" : "Kun Käytössä, varauksen aikana perittävä summa kerrotaan Kautta Yhteensä luku - osallistujat, vieraat mukaan lukien",
      "first_appointment_only" : "veloitus vain ensimmäiselle Tapatukselle",
      "all_appointments" : "veloitus Tapaaminen etukäteen",
      "no_payment_provider_connected" : "Ei maksua Palveluntarjoaja yhdistetty",
      "no_default_payment_provider" : "Ei maksua Palveluntarjoaja yhdistetty",
      "provider_not_supported" : "Oletus-maksua Palveluntarjoajaa ei tueta",
      "manage_payment_provider" : "Hallinnoida maksupalveluntarjoajia",
      "supported_providers" : "Tuetut palveluntarjoajat",
      "paypal_razorpay_helper_text" : "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order" : "Siirtää Widget Järjestää",
      "change_form_order" : "Dynaaminen the Lomake to Widget in tulee poistaa Perässä oleva Asetus:",
      "change_form_order_desc" : "<b>Uusi ajanvarausasetus (Varaa aina kontaktin {contactLabel} määrittämän käyttäjän kanssa)</b> poistetaan käytöstä. Tämä tarkoittaa, että tapaamisia voi varata kenelle tahansa vapaana olevalle tiimin jäsenelle sen sijaan, että ne rajoittuisivat kontaktin {contactLabel} määrittämään käyttäjään.",
      "enable_mandatory_guest" : "Luoda lisäämällä vähintään yhden Vieras Pakollisen. Vieras Kentät avataan ennakkoon ja on täytettävä Ennen varausta.",
      "enable_mandatory_guest_count" : "Ota Ajanvaraus-widget Pakollinen Vieras Lukumäärä Päällä",
      "require_guest_for_booking" : "Pakolliset vieraat varaukseen",
      "sticky_contacts_tooltip" : "Täytä kentät automaattisesti tunnetuille kontakteille {contactsLabel}.",
      "auto_confirm_tooltip" : "Vesileima uusi kokoontuu automaattisesti nimellä Vahvistettu ilman Manuaalinen Hyväksyntä. Poista tämä Jos Sinä/Te haluat Arvosteluun ja vahvistaa varauksen manuaalisesti Ennen sen Ajoitettua",
      "confirm_tooltip" : "Kun joku on tehnyt varauksen, Sinä/Te voi Valita hänelle a Mukautettu Viesti Päällä sama Sivu (Oletus) Tai uudelleenohjaa hänet - valitsemasi sivulle (Uudelleenohjauksen URL-osoite)",
      "facebook_pixel_id_tooltip" : "",
      "accept_payments_tooltip" : "Ottaa käyttöön Kokoelma käyttöön varausten aikana",
      "total_amount_tooltip" : "Kokoelma Osallistua neuvotteluun Kokoelmaveloitus",
      "deposit_amount_tooltip" : "Varauksen yhteydessä perittävä summa talletuksena",
      "multiply_amount_guests_all_guests" : "Peri maksuja osallistujista, vieraat mukaan lukien",
      "multiply_amount_guests_all_guests_tooltip" : "Kun Käytössä, varauksen aikana perittävä summa kerrotaan Kautta Yhteensä luku - osallistujat, vieraat mukaan lukien",
      "payment_description" : "Kuvaus",
      "payment_description_tooltip" : "Valinnaisesti Sisällyttää kaikki hyödylliset yksityiskohdat – maksu",
      "test_mode_warning" : "Testaustila Dynaaminen – aitoa Myyntiä ei käsitellä.",
      "pixel_id_tooltip" : "Ladata Ajanvaraus-widget Toiminta Tykätä Näkymät, klikkaukset ja vastauslähetykset Meta Kauttaan Pikselin tunnussi",
      "forms_description" : "Määrittää Kentät ja Virtaus - varauksesi Lomake",
      "payment_mode" : "Maksutapa",
      "payment_mode_tooltip" : "Vaihda Testaustilan ja Suoran välillä; live; reaaliaikainen maksutila. in ei tehdä oikeita laskutuksia — simuloi sillä varausta ja maksua Työnkulku. Vaihda Suoraan; live; reaaliaikainen tila hyväksyä todelliset maksut - asiakkaiden.",
      "enable_coupon" : "Ota kuponkikoodit käyttöön",
      "enable_coupon_tooltip" : "Salli asiakkaiden käyttää kuponkikoodeja varauksen yhteydessä. Varmista niiden toimivuus luomalla ensin voimassa olevat kupongit kohdassa Maksut > Kuponkikoodit."
    },
    "notifications" : {
      "notifications" : "Muistutus & Lisä Vallinnat",
      "notifications_sub" : "Määrittää Ilmoitus ja muut Vallinnat",
      "edit" : "Muokkaa",
      "created_on" : "Luotu",
      "updated_on" : "Päivitetty",
      "delivered" : "Toimitettu",
      "not_available" : "–",
      "select_notification_type" : "Valita the Kirjoittaa - Ilmoitus",
      "notification_person" : "Kenen pitäisi Periä tämä Ilmoitus?",
      "contact" : "{contactLabel}",
      "guest" : "Vieras",
      "assigned_user" : "Määritetty käyttäjät",
      "emails" : "Gmail",
      "alert_email_address" : "Hälytys sähköpostiosoite",
      "ack_email" : "Vahvistus sähköposti",
      "send_google_invites" : "Ottaa käyttöön Google Calendar Ladata-kutsuun Tai päivitä Gmail osallistujille.",
      "send_google_outlook_invites" : "Ottaa käyttöön Google- / Outlook- / iCloud-kalenteri lähettääksesi kutsuja ja päivittääksesi sähköposteja osallistujille.",
      "assign_user_to_contact" : "Määritä {contactsLabel} vastaaville kalenterin tiimin jäsenille joka kerta, kun tapaaminen varataan",
      "skip_assigning_user_to_contact" : "Ohita kontaktin {contactLabel} määrittäminen, jos {contactLabel} on jo määrittänyt käyttäjän",
      "assigned_staff" : "Määritetty henkilökunta",
      "additional_emails" : "Ylimääräinen Gmail",
      "assign_user_to_staff" : "Määritä {contactsLabel} vastaaville palveluhenkilöstön jäsenille joka kerta, kun tapaaminen varataan",
      "allow_cancellation" : " Otaa käyttöön Peruutus - Osallistua neuvotteluun",
      "allow_reschedule" : "Ota käyttöön Uudelleenaikataulu - Osallistua neuvotteluun",
      "allow_cancellation_tooltip" : "Kun Käytössä, peruutus Linkki lisätään Osioon ja sisällytetään in . Tämä Linkki tulee Vanhentunut sellaisena kuin se on määritetty Ennen osallistua neuvotteluun alkamispäivämäärä, estäen Buukkaajan - peruuttamalla Osallistua neuvotteluun.",
      "allow_reschedule_tooltip" : " Kun Käytössä, uudelleenajoitettu Linkki lisätään Osioon ja sisällytetään in . Tämä Linkki tulee Vanhentunut määrityksen mukaisesti Ennen osallistua neuvotteluun alkamispäivämäärä, estäen Buukkaajan - Osallistua neuvotteluun uudelleenajoittaminen.",
      "cancellation_link_expiry" : "Peruutus Linkki tulee Vanhentunut",
      "reschedule_link_expiry" : "Ajanvaraus Linkki tulee Vanhentunut",
      "before_meeting" : "Ennen kuin Osallistua neuvotteluun",
      "cancellation_and_reschedule_policy" : "Peruutus- ja Siirtää :",
      "meeting_invite_notes" : "Osallistua neuvotteluun Kutsumuistiinpanot",
      "meeting_invite_notes_tooltip" : "in ilmestyvät lisätyt muistiinpanot kutsuvat lähetettynä niihin. Nämä muistiinpanot Synkronointia Kolmannen osapuolen kalenterit Osallistua neuvotteluun in"
    },
    "connections" : {
      "connections_heading" : "Kolmannen osapuolen kalenterit Synkronointi",
      "connections_sub" : "Synkronointi tapahtumat with Kolmannen Osapuolen kalenterit",
      "link_to_calendar" : "Linkki kalenteriin",
      "sync_option" : "Synkronointi",
      "execute_automation" : "Suorita automaatio",
      "fire_workflow" : "Käynnistä työnkulun käynnistimet tapahtumille, jotka on varattu kaksisuuntaisen synkronoinnin kautta",
      "reserve_with_google" : "Varata Google kanssa [jatkossa poistetaan käytöstä]",
      "reserve_with_google_setup" : "Katsoa Konfiguraatio -ohjeet",
      "reserve_with_google_configure" : "Määrittää",
      "change" : "Muuta",
      "rwg_deprecation_notice" : "Google on <strong>poistanut käytöstä Varata with Google (RwG)</strong>, joka tunnetaan nimellä <strong>Local Palvelut Mainokset</strong>. uusi-yhteyksiä ei enää tueta. Käytä Jatkaa Vastaanotettuun Kautta Google -varaukseen sen sijaan <strong>Google Organic Booking</strong> .",
      "rwg_category" : "Kategoria",
      "rwg_service_type" : "Palvelu",
      "connect_lsa" : "Ota yhteyttä paikalliseen Palvelut Mainostiliin",
      "reserve_error" : "nyt Varata with Google on tuettu vain \"Home Palvelut\", \"Real Estate\", \"Legal Palvelut\" Yritys Niche in .",
      "one_way" : "Yksi tapa",
      "two_way" : "Kaksisuuntainen",
      "smart" : "Älykäs",
      "confirm_remove" : "Haluatko Sinä/Te varma Sinä/Te Poimia Google Calendariin?",
      "read_only_access" : "Sinä/Te ei ole kirjoittamalla Pääsy tähän kalenteriin. Valitse toinen kalenteri.",
      "reserve_with_google_desc" : "Tämä kalenteripalvelu in Varataan vain Google kanssa Päällä onnistunut Integrointi.",
      "check_integration" : "DNS-merkkisi, joka on Integrointi Tilasi",
      "setup_external" : "Konfiguraatio your Kolmannen osapuolen kalenterit",
      "reserve_price_decimal_error" : "Desimaalin hintaa ei tueta",
      "reserve_price_max_error" : "Tuettu Hinta alle 1 000",
      "link_to_calendar_tooltip" : "Valitse kalenteri, jonka kanssa Sinä/Te haluat synkronoida tämän kalenterin",
      "one_way_sync" : "Yksisuuntainen",
      "default_one_way" : "Oletussynkronointi (yksisuuntainen synkronointi)",
      "one_way_sync_desc" : "Kolmannen osapuolen kalenteritapahtumat synkronoidaan estettyinä aikoina, eikä osallistujista luoda kontakteja.",
      "two_way_sync" : "Kaksisuuntainen synkronointi",
      "two_way_sync_desc" : "Kolmannen osapuolen kalenteritapahtumissa olevista vieraista luodaan kontaktit, ja nämä tapahtumat muutetaan järjestelmän tapaamisiksi.",
      "smart_sync" : "Älykäs synkronointi",
      "smart_sync_desc" : "Linkitetyn kalenterin tapahtumat synkronoidaan olemassa olevien kontaktien tapaamisiksi. Jos kontakteja ei ole, ne synkronoidaan estettyinä aikoina ilman, että luodaan uutta kontaktia.",
      "sync_option_tooltip" : "Valitse, miten ulkoisen kalenterisi tapahtumat synkronoidaan tämän kalenterin kanssa. Voit estää vain saatavuuden tai myös luoda/hallita kontaktia {contactsLabel} ja tapaamisia täällä valitsemasi synkronointitilan mukaan.",
      "one_way_sync_tooltip" : "Blocks Päivämäärä aikavälit Kautta tuodaan kiireinen Tapahtumat - sinun Kolmannen osapuolen kalenterit",
      "two_way_sync_tooltip" : "Tuo kokoukset ja luo {contactsLabel}, tapaamiset järjestelmään. Tässä tehdyt muutokset näkyvät ulkoisessa kalenterissa.",
      "smart_sync_tooltip" : "Tuo kokoukset ja luo tapaamisia vain, jos kokouksen on luonut tunnettu {contactLabel}",
      "default_sync" : "Oletus",
      "default_sync_desc" : "Synkronoi ulkoisen kalenterin tapahtumat tähän kalenteriin",
      "advanced_sync" : "Edistynyt",
      "advanced_sync_desc" : "Synkronoi ulkoisen kalenterin tapahtumat tähän kalenteriin ja luo yhteystietoja ja tapaamisia järjestelmään",
      "assign_contact_to" : "Määritä kontakti kohteelle",
      "select_calendar" : "Valitse kalenteri",
      "sync_preferences" : "Synkronointiasetukset",
      "sync_preferences_desc" : "Miten haluat synkronoida tapahtumat kolmannen osapuolen kalenteristasi?",
      "recommended" : "Suositeltu",
      "execute_automation_desc" : "Suorita automaatio, kun tähän kalenteriin luodaan kokous",
      "save" : "Tallenna muutokset",
      "cancel" : "Peruuta"
    },
    "extras" : {
      "extras" : "Räätälöinnit",
      "extras_sub" : "Kokoelma- Widget -tyyli ja Muu Asetukset.",
      "calendar_widget_style" : "Kalenteri- Widget -tyyli",
      "neo" : "Uusi",
      "classic" : "Klassinen",
      "insert_custom_code" : "Lisää custom-koodi",
      "show_seats_per_slot" : "näkyy Paikat per aikaväli",
      "allow_reschedule_meeting" : "Ota käyttöön Siirtää Osallistua neuvotteluun",
      "allow_cancelling_meeting" : "Otaa peruuttaa Osallistua neuvotteluun",
      "additional_notes" : "Lisähuomautukset",
      "cancellation_and_reschedule" : "Peruutus ja Siirtää:",
      "allow_staff" : "Ota käyttöön henkilökuntavalinta varauksen yhteydessä",
      "code_block_tooltip" : "Kolmansien osapuolten komentosarjat Sisempi HTML lohko voi Tarjous tehokkaita toiminnallisuuksia, mutta niihin liittyy myös tietosuojaa, turvallisuutta, suorituskykyä ja Sivun toimintaa koskevia riskejä. Siksi suosittelemme, että Sinä/Te to Arvostelu the Sisältö - tämä Koodi Ennen Tallennetaan sen kalenteriin.",
      "calendar_image" : "Kalenterin Kansikuva",
      "remove_image" : "Poimia Kuva",
      "calendar_image_info" : "Ladattu Kuva näkyy Neo Mallipohjan Ryhmä Katsossa eikä näy Päällä the Yksilöllinen kalenteri Linkki",
      "get_image_from_unsplash" : "Paranna visuaalisuuttasi:",
      "unsplash" : "Unsplash",
      "service_additional_preferences" : "Määrittää Lisäasetukset",
      "service_image" : "Palvelun Kansikuva",
      "service_image_description" : "Valita an Kuva, joka olisi Osallistunut Päällä tämän palvelun Palvelut-valikkoon",
      "allow_reschedule_appointment" : "Ota käyttöön Siirtää Tapaaminen",
      "allow_cancelling_appointment" : "Ota käyttöön peruutettu Tapaaaminen",
      "custom_code_placeholder" : "Palauta Custom-koodi tässä",
      "calendar_widget_style_desc" : "Valita Klassinen Tai tyylikkään Neo Widget välillä",
      "seats_per_slot" : "Paikat per aikaväli",
      "show_staff_selection" : "Henkilökunnan valinta",
      "seats_per_slot_desc" : " Ottaa käyttöön Buukkaaja to Katsoa luku - saatavilla Paikat per Aikaikkuna suoraan Päällä kalenteri - Widget.",
      "show_staff_selection_desc" : "Ottaa käyttöön Buukkaaja Valita a henkilökunnan Jäsenetille - kalenteri- Widget Tapaaminen-varauksen yhteydessä. Toimii vain Neo Widget kanssa",
      "widget_re_order_tooltip" : "Klassinen Widget -tyyli ei Ottaa käyttöön Widget Järjestää Dynaaminen. Varmista, että Päivämäärän päivämäärän valitsin on ensimmäinen ja Lomake toinen ennen Klassinen-tyylin valitsemista.",
      "show_staff_selection_desc_service" : "Ottaa käyttöön Buukkaaja Valita a henkilökunnan Jäsenetille - kalenteri- Widget Tapaaminen-varauksen yhteydessä.",
      "switch_to_classic_widget" : "Vaihda Klassinen Widget",
      "switch_to_classic_widget_desc" : "Dynaaminen to <b>Klassinen- Widget</b> poistaa Perässä olevat Asetukset automaattisesti, sillä ne eivät voi olla rinnakkain:",
      "form_first_disabled" : "<b>Lomake siirretään</b> Widget in toiseen Vaiheen.",
      "appointment_preference_disabled" : "<b>Uusi ajanvarausasetus (Varaa aina kontaktin {contactLabel} määrittämän käyttäjän kanssa)</b> poistetaan käytöstä. Tämä tarkoittaa, että tapaamisia voi varata kenelle tahansa vapaana olevalle tiimin jäsenelle sen sijaan, että ne rajoittuisivat kontaktin {contactLabel} määrittämään käyttäjään.",
      "multiple_location_disabled" : "<b>Useita Osallistua neuvotteluun Osoite</b> Poistettu, ja vain <b>ensimmäiseksi lisätty sijainti</b> säilyy.",
      "insert_custom_code_tooltip" : "Mukauttaa Widget -muotoilu Kautta oma CSS Koodisi",
      "classic_tooltip_disabled" : "Klassista widgetiä ei tueta luokkien varauskalentereissa",
      "show_staff_selection_disabled_tooltip" : "Työntekijän valintaa tuetaan vain Neo-widgetissä"
    },
    "roomsAndEquipments" : {
      "title" : "Valita Huone ja Laitteet",
      "description" : "Valita - a Luettelo - Huone ja Laitteet mitä varataan tämän kalenterin mukana",
      "rooms" : "Valita Huone",
      "equipments" : "Valita Laitteet"
    }
  },
  "activity_log" : {
    "activity_log" : "Toimintaloki",
    "date" : "Päivämäärä",
    "filter_by" : "Suodatusperuste:",
    "calendar_update" : "Kalenterin päivitys",
    "start_time_update" : "Alkamisajan päivitys",
    "end_time_update" : "Päättymisajan päivitys",
    "title_update" : "Otsikon päivitys",
    "notes_update" : "Muistiinpanojen päivitys",
    "appointment_status_update" : "Tapaamisen tilan päivitys",
    "meeting_location_update" : "Tapaamispaikan päivitys",
    "google_sync_update" : "Google-synkronoinnin päivitys",
    "outlook_sync_update" : "Outlook-synkronoinnin päivitys",
    "assigned_user_update" : "Määritetyn käyttäjän päivitys",
    "appointment_status" : "Tapaamisen tila",
    "assigned_user" : "Määritetty käyttäjä",
    "uploaded_to" : "Ladattu seuraavaan:",
    "cancelled" : "Peruutettu",
    "edited" : "muokattu",
    "other_edits" : "Muut muokkaukset",
    "view_details" : "Näytä tiedot",
    "all" : "Kaikki"
  },
  "appointment_list" : {
    "group_all" : "KAIKKI",
    "group_primary" : "ENSISIJAINEN",
    "group_user" : "KÄYTTÄJÄT",
    "group_team" : "RYHMÄT",
    "group_calendar" : "KALENTERIT",
    "all_appointments" : "Kaikki tapaamiset",
    "my_calendar" : "Oma kalenteri",
    "status_all" : "Kaikki",
    "status_confirmed" : "Vahvistettu",
    "status_new" : "Uusi (toimenpiteitä vaaditaan)",
    "status_show" : "Osallistunut",
    "status_no_show" : "Ei osallistunut",
    "status_cancelled" : "Peruutettu",
    "status_invalid" : "Virheellinen",
    "filter_date_added_desc" : "Lisäämispäivä (laskeva)",
    "filter_start_added_desc" : "Alkamispäivä (laskeva)",
    "filter_start_added_asc" : "Alkamispäivä nousevassa järjestyksessä tästä päivästä",
    "button_new_appointment" : "Uusi tapaaminen",
    "name" : "Nimi",
    "title" : "Otsikko",
    "requested_time" : "Pyydetty aika",
    "date_added" : "Lisäämispäivä",
    "calendar" : "Kalenteri",
    "appointment_owner" : "Tapaamisen omistaja",
    "notes" : "Muistiinpanot",
    "status" : "Tila",
    "action_view_detail" : "Näytä tiedot",
    "action_view_consent" : "Näytä suostumus",
    "action_view_notes" : "Näytä muistiinpanot",
    "action_edit" : "Muokkaa",
    "action_delete" : "Poista",
    "action_reschedule" : "Siirrä ajankohtaa",
    "page_previous" : "Edellinen",
    "page_next" : "Seuraava",
    "appointment_notes" : "Tapaamista koskevat muistiinpanot",
    "close" : "Sulje",
    "confirm_delete_header" : "Poista tapaaminen",
    "confirm_delete_message" : "Haluatko varmasti poistaa tämän tapaamisen? Tätä toimintoa ei voi kumota!",
    "confirm_delete_button" : "Poista",
    "confirm_update_header" : "Päivitä tapaamisen tila",
    "confirm_update_confirmed_message" : "Haluatko varmasti merkitä tämän tapaamisen vahvistetuksi?",
    "confirm_update_invalid_message" : "Haluatko varmasti merkitä tämän tapaamisen virheelliseksi?",
    "confirm_update_showed_message" : "Haluatko varmasti merkitä tämän tapaamisen toteutuneeksi?",
    "confirm_update_noshow_message" : "Haluatko varmasti merkitä tämän tapaamisen peruuttamatta jätetyksi?",
    "confirm_update_cancelled_message" : "Haluatko varmasti merkitä tämän tapaamisen peruutetuksi?",
    "confirm_update_button" : "Päivitä",
    "empty_state_title" : "Tapaamisia ei löytynyt",
    "empty_state_description" : "Tapaamisia ei löytynyt",
    "disable_menu_warning" : "Sinulla ei ole tällä hetkellä oikeutta katsoa tai muokata tapaamisen tietoja, sillä siihen liittyvää kontaktia ei ole määritetty sinulle. Lisätietoja saat ottamalla yhteyttä ylläpitäjään.",
    "no_contact_warning" : "Kontaktin tiedot eivät ole tällä hetkellä katsottavissasi. Tämä voi johtua siitä, että kontaktia ei ole määritetty sinulle. Lisätietoja saat ottamalla yhteyttä ylläpitäjään.",
    "consent_label" : "Suostumus",
    "ip_address" : "IP",
    "youre_viewing_in" : "Katsellaan tällä hetkellä seuraavassa:",
    "appointment_delete_msg" : "<b>Huom.</b> Täältä poistettua tapaamista ei poisteta Calendlysta.",
    "rescheduled" : "Ajoitettu uudelleen"
  },
  "add_guest" : {
    "guest_label" : "Vieras(vieraat)",
    "search_placeholder" : "Hakea – Kaveri",
    "add_new" : "Lisätä uusi",
    "save" : "Arkistoida",
    "close" : "Sulkea",
    "name" : "Nimi",
    "phone" : "Puhelin",
    "email" : "Sähköposti",
    "guest_label_count" : "Vieras(s) Lukumäärä",
    "guest_count_error" : "Vieras Lukumäärän tulee olla 1–100"
  },
  "languages" : {
    "danish" : "Danish",
    "dutch" : "Dutch",
    "english" : "English",
    "finnish" : "Finnish",
    "french" : "French",
    "french_canada" : "French (Canada)",
    "german" : "German",
    "hungarian" : "Hungarian",
    "italian" : "Italian",
    "norwegian" : "Norwegian",
    "polish" : "Polish",
    "portuguese_brazil" : "Portuguese (Brazil)",
    "portuguese_portugal" : "Portuguese (Portugal)",
    "spanish" : "Spanish",
    "swedish" : "Swedish",
    "turkish" : "Turkish"
  },
  "service_menu_advanced" : {
    "new_service_menu_details_header" : "Palveluvalikon Yksityiskohdat",
    "select_groups_header" : "Valita Palvelut",
    "arrange_groups_header" : "Määrittää Palvelusi",
    "new_service_menu" : "uusi palveluvalikko",
    "service_menu_sub_title" : "Luoda a Mukautettu -palvelumenu asiakkaillesi vain muutamalla in",
    "quick_tip" : "Sinä/Te can Sisällyttää Ryhmää palveluvalikkoon",
    "service_menu_name" : "Palveluvalikon kohteen nimi",
    "service_menu_description" : "Kuvaus",
    "service_menu_slug" : "Palvelun URL-osoite",
    "select_groups_calendars" : "Valita Ryhmä ja kalenterit",
    "select_groups_calendars_desc" : "Lisätä Palvelut palveluvalikkoon",
    "select_all" : "Valita huone",
    "arrange_groups" : "Määrittää Järjestää - Palvelut",
    "arrange_groups_desc" : "Määritä Prosessi - Palvelut Päällä palveluvalikko",
    "arrange_services_quicktip" : "Siirry Ryhmän Siirtään kalentereihin kohdasta Ryhmä > Vallinnat > Siirtää kalenterit.",
    "enable_add_guest_desc" : "Ottaa käyttöön asiakkaille Sisällyttää lisävieraita Kun varauksen yhteydessä.",
    "enable_multiple_service_desc" : "Ottaa käyttöön Varata useille Palveluille in Tapassa.",
    "enable_staff_selection_desc" : "Ottaa käyttöön tuotteen Valitaan ensisijainen henkilökunta Jäsenet Kun varausta tekevässä.",
    "enable_add_guest" : "Ottaa käyttöön Lisätä vieraita käyttöön",
    "enable_multiple_service" : "Ottaa käyttöön usean palvelun valinta käyttöön",
    "enable_staff_selection" : "Ottaa käyttöön henkilöstövalinta käyttöön",
    "additional_options" : "Valinnat",
    "code_block_tooltip" : "Kolmansien osapuolten komentosarjat Sisempi HTML lohko voi Tarjous tehokkaita toiminnallisuuksia, mutta niihin liittyy myös tietosuojaa, turvallisuutta, suorituskykyä ja Sivun toimintaa koskevia riskejä. Siksi suosittelemme, että Sinä/Te to Arvostelu on Sisältö - tämä Koodi Ennen Tallennetaan sen palveluvalikkoon.",
    "custom_code_placeholder" : "Palauta Custom-koodi tässä",
    "insert_custom_code" : "Lisää custom-koodi",
    "no_service" : "Palvelua ei löydetty",
    "no_service_desc" : " Ei Palvelut löytääty. Luoda Palvelut ja Sisällyttää ne Ryhmään Luodaan palvelumenu.",
    "learn_more" : "Lue lisää",
    "no_service_selected" : "Ei palvelua Valittu",
    "create_service_calendars" : "Luoda palvelukalentereita",
    "alert_description" : " in Järjestää Luodaan -palveluvalikosta Sinä/Te tarvitsee Luoda-palvelukalenterit ja Sisällyttää ne Ryhmään",
    "dont_show_again" : "Älä tee tätä uudelleen",
    "service_name_required" : "Palveluvalikonin kohteen nimi on Pakollinen",
    "slug_already_taken" : "Tämä Kestolinkki on jo varattu",
    "slug_required" : "Kestolinkki on Pakollinen",
    "please_enter_name" : "Kirjoita nimi",
    "service_name_placeholder" : "ENSISIJAINEN Menu",
    "service_slug_placeholder" : "päävalikko",
    "form_label" : "Lomake",
    "consent_label" : "Suostumus Valintaruutu",
    "consent_input_placeholder" : "Lisätä Suostumus Runko",
    "consent_tooltip" : "Ota tämä vaihtoehto käyttöön, jos haluat sallia kontaktin {contactsLabel} suostumuksen pyytämisen, kun tämä antaa puhelinnumeronsa ajanvarauksen yhteydessä.",
    "back_message" : "Takaisin Luettelo",
    "saving_changes" : "Vain hetkinen — Tallennetaan uusin Dynaaminen...",
    "payment_provider_warning" : "Huomio! Palveluvalikot tukevat tällä hetkellä maksuja vain Stripen ja Authorize.netin kautta. Koska oletuspalveluntarjoajasi on jokin muu, maksujen kerääminen valituista kalentereista, joissa maksut ovat käytössä, ohitetaan.",
    "aria" : {
      "consent_form_toggle" : "Hyväksyntä-lomakkeen kytkin",
      "enable_add_guest_toggle" : "Ota Lisää vieras -valinta käyttöön",
      "enable_multiple_services_toggle" : "Ota Useita palveluja -valinta käyttöön",
      "enable_staff_selection_toggle" : "Ota Henkilöstön valinta käyttöön"
    }
  },
  "widget_configuration" : {
    "customise_calendar_widget" : "Mukauttaa kalenteri- Widget",
    "works_with_neo_widget" : "Toimii vain Neo Widget kanssa",
    "customise_widget_desc" : "Mukauttaa Widget Ulkoasu: ENSISIJAINEN Väri, Tausta Väri ja Painike Runko.",
    "learn_more" : "Lue lisää",
    "primary_settings" : "ENSISIJAINEN Asetukset",
    "primary_settings_desc" : "Määrittää kalenterisi ENSISIJAINEN Väri-, Tausta Väri- ja Muu - Widget Asetukset ja Mukauttaa",
    "primary_color" : "ENSISIJAINEN Väri",
    "primary_color_desc" : "Määritä Väri kohteelle Painike, päivämäärät, Päivämäärä-välit ja toiminnot",
    "background_color" : "Tausta Väri",
    "background_color_desc" : "Kokoelma Tausta Väri, joka toimii sekä treffituntin valitsimen että Lomakkeen taustana.",
    "button_text" : "Painike Runko",
    "button_text_desc" : "Mukauttaa the Runko näytti Päällä the Painike Kunin tapaamisen varaamisen",
    "calendar_title" : "Kalenterin Otsikko",
    "calendar_title_desc" : "Nimi – kalenterisi",
    "calendar_description" : "Kalenterin Kuvaus",
    "calendar_description_desc" : "Lisätyt Kuvaus",
    "calendar_details" : "Kalenterin Yksityiskohdat",
    "calendar_details_desc" : "Sisältää yksityiskohdat, kuten Kesto, Päivämäärä & päivämäärä, Toistuva yksityiskohdat ja aikavyöhyke",
    "reset_to_default" : "Nollata Oletukselle",
    "preview_widget" : "Esikatselu Widget",
    "calendar_title_tooltip" : "Kokoelma Jos kalenterin nimen ja Ryhmän nimen tulee olla näkyvissä Päällä Ajanvaraus-widgetissä.",
    "calendar_description_tooltip" : "Kokoelma Jos the Calendar Kuvaus tulee olla näkyvissä Päällä the Ajanvaraus-widget.",
    "calendar_details_tooltip" : "Kokoelma Jos Avain- tapaamisten yksityiskohtien, kuten Osallistua neuvotteluun Kesto, Valittu päivämäärä & Päivämäärä sekä toistumistietojen (Jos) tulee olla näkyvissä Päällä Ajanvaraus-widgetissä.",
    "insert_custom_code_tooltip" : "Mukauttaa Widget -muotoilu Kautta oma CSS Koodisi.",
    "staff_selection_tooltip" : "Ottaa käyttöön Buukkaaja Valita a henkilökunnan Jäsenetille - kalenteri- Widget Tapaaminen-varauksen yhteydessä. Toimii vain Neo Widget kanssa."
  },
  "eventNotification" : {
    "customFields" : "Mukautettu Kentät",
    "customValues" : "Mukautetut arvot",
    "guest" : "Vieras",
    "assignedUser" : "Määritetty käyttäjä",
    "additionalEmails" : "Lisäsähköpostit",
    "list" : {
      "booked" : {
        "title" : "Tapaaminen varattu (tila: Ei vahvistettu)",
        "note" : "Tämä ilmoitus lähetetään, kun uusi tapaaminen luodaan Vahvistamaton-tilaa käyttämällä.",
        "subTitle" : "Ilmoittaa, kun varaus on tehty ja sen tila on vahvistamaton."
      },
      "confirmation" : {
        "title" : "Tapaaminen varattu (tila: Vahvistettu)",
        "note" : "Tämä ilmoitus lähetetään, kun tapaaminen luodaan Vahvistettu-tilaa käyttämällä tai se päivitetään siihen.",
        "subTitle" : "Ilmoittaa, kun varaus on vahvistettu onnistuneesti"
      },
      "cancellation" : {
        "title" : "Peruutus",
        "note" : "Tämä ilmoitus lähetetään, kun tapaaminen peruutetaan, merkitään ilmestymättä jäämiseksi tai merkitään virheelliseksi.",
        "subTitle" : "Hälyttää, kun tapaaminen peruutetaan"
      },
      "reschedule" : {
        "title" : "Siirrä ajankohtaa",
        "note" : "Tämä Ilmoitus on lähetetty Kun an Tapaaminen on ajoitettu uudelleen. Se käynnistyy vain Jos the Tapaaminen on in Tai Vahvistettu Tilassa.",
        "subTitle" : "Ilmoittaa, kun tapaamisen ajankohtaa siirretään"
      },
      "reminder" : {
        "title" : "Muistutus",
        "note" : "Tämä Ilmoitus on lähetetty Muistutuksena Ennen the Tapaaminen. Se käynnistyy vain Jos the Tapaaminen on in Tai Vahvistettu Tilassa.",
        "subTitle" : "Lähettää muistutuksen ennen tapaamista"
      },
      "followup" : {
        "title" : "Seuranta",
        "note" : "Tämä ilmoitus lähetetään tapaamisen jälkeen seurantatoimenpiteenä. Se käynnistyy vain, jos tapaaminen on Vahvistamaton-, Vahvistettu- tai Osallistunut-tilassa.",
        "subTitle" : "Lähettää seurantaviestin tapaamisen jälkeen"
      }
    },
    "saveToastMsg" : "Asetukset tallennettiin!",
    "saveToastMsgDesc" : "Muutoksesi on tallennettu onnistuneesti",
    "enableSuccess" : "Muistutus Käytössä!",
    "disableSuccess" : "Muistutus Poistettua!",
    "tooltip" : "Tämä ilmoitus on poistettu käytöstä. Ota se käyttöön muutosten tekemistä varten.",
    "enabled" : "Käytössä",
    "disabled" : "Poistettu käytöstä",
    "statusLabel" : "Tilatunnisteet",
    "email" : {
      "channelName" : "Sähköposti",
      "noneTemplate" : "Ei mitään",
      "notificationLabel" : "Kenelle tämä ilmoitus pitäisi lähettää?",
      "sendButtonLabel" : "Lähetä testisähköposti",
      "testEmailLabel" : "Testisähköposti",
      "testEmailPlaceholder" : "Anna vastaanottajan sähköpostiosoite testausta varten",
      "body" : "Sähköpostiviestin runko",
      "bodyPlaceholder" : "Kirjoita viestisi tähän",
      "subject" : "Aihe",
      "subjectPlaceholder" : "Anna sähköpostin aihe",
      "templateLabel" : "Sähköpostimalli",
      "templatePlaceholder" : "Valitse sähköpostimalli tai aloita tyhjästä",
      "fromNamePlaceholder" : "Anna nimi",
      "fromNameLabel" : "- Nimi",
      "fromAddressLabel" : "- Osoite",
      "alertEmailAddress" : "Anna sähköpostitunnukset (Erotettu Kautta pilkkua)",
      "addMore" : "Lisää muita",
      "afterAppointmentEnds" : "tapaamisen päättymisen jälkeen",
      "beforeAppointmentStarts" : "ennen tapaamisen alkamista",
      "durationLabel" : "Milloin haluat käynnistää ilmoituksen lähettämisen?",
      "disableEmailNotification" : "Poista sähköposti-ilmoitukset käytöstä",
      "enableEmailNotification" : "Ota sähköposti-ilmoitukset käyttöön",
      "enableSuccess" : "Sähköposti-ilmoitus käytössä!",
      "enableSuccessDesc" : "Alat nyt saamaan tämän ilmoituksen",
      "disableSuccess" : "Sähköposti-ilmoitus poistettu käytöstä!",
      "disableSuccessDesc" : "Et saa enää tätä ilmoitusta",
      "reset_to_default" : "Nollata Oletukselle",
      "testEmailSuccessTitle" : "Testisähköposti lähetetty!",
      "testEmailSuccessDesc" : "Testisähköposti on lähetetty onnistuneesti osoitteeseen {email}",
      "testEmailErrorTitle" : "Testisähköpostin lähettäminen epäonnistui",
      "testEmailErrorDesc" : "Testisähköpostin lähettämisessä tapahtui virhe. Yritä uudelleen."
    },
    "inApp" : {
      "channelName" : "Sovelluksen sisäinen",
      "title" : "Ilmoitusasetukset",
      "enableInAppNotification" : "Ota sovelluksen sisäiset ilmoitukset käyttöön",
      "disableInAppNotification" : "Poista sovelluksen sisäiset ilmoitukset käytöstä",
      "selectedUser" : {
        "label" : "Lähetä vastaanottajalle",
        "helperText" : "Tämä sisäinen ilmoitus lähetetään verkko- ja mobiilisovellusten kautta.",
        "placeholder" : "Valitse käyttäjä(t)"
      },
      "enableSuccess" : "Sovelluksen sisäiset ilmoitukset otettu käyttöön!",
      "enableSuccessDesc" : "Alat nyt saamaan tämän ilmoituksen",
      "disableSuccess" : "Sovelluksen sisäiset ilmoitukset poistettu käytöstä!",
      "disableSuccessDesc" : "Et saa enää tätä ilmoitusta"
    },
    "sms" : {
      "channelName" : "SMS",
      "noneTemplate" : "Ei mitään",
      "notificationLabel" : "Kenelle tämä ilmoitus pitäisi lähettää?",
      "sendButtonLabel" : "Lähetä testi-SMS",
      "testSMSLabel" : "Testi-SMS (anna puhelinnumero maakoodin kanssa)",
      "testSMSPlaceholder" : "+12345678901",
      "body" : "SMS-viesti",
      "bodyPlaceholder" : "Kirjoita SMS-viesti tähän",
      "durationLabel" : "Milloin haluat käynnistää ilmoituksen lähettämisen?",
      "disableSMSNotification" : "Poista SMS-ilmoitukset käytöstä",
      "enableSMSNotification" : "Ota SMS-ilmoitukset käyttöön",
      "enableSuccess" : "SMS-ilmoitus käytössä!",
      "enableSuccessDesc" : "Alat nyt saamaan tämän ilmoituksen",
      "disableSuccess" : "SMS-ilmoitus poistettu käytöstä!",
      "disableSuccessDesc" : "Et saa enää tätä ilmoitusta",
      "alertPhoneNumbers" : "Anna puhelinnumerot (maakoodien kanssa pilkuin eroteltuina)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Lisää muita",
      "afterAppointmentEnds" : "tapaamisen päättymisen jälkeen",
      "beforeAppointmentStarts" : "ennen tapaamisen alkamista",
      "templateLabel" : "SMS-mallipohja",
      "templatePlaceholder" : "Valitse SMS-mallipohja...",
      "reset_to_default" : "Palauta oletusarvoon",
      "testSmsSuccessTitle" : "Testi-SMS lähetetty!",
      "testSmsSuccessDesc" : "Testi-SMS on lähetetty onnistuneesti numeroon {phone}",
      "testSmsErrorTitle" : "Testi-SMS:in lähettäminen epäonnistui",
      "testSmsErrorDesc" : "Testi-SMS:n lähettämisessä tapahtui virhe. Yritä uudelleen."
    },
    "whatsapp" : {
      "channelName" : "WhatsApp",
      "notificationLabel" : "Kenelle tämä ilmoitus pitäisi lähettää?",
      "sendButtonLabel" : "Lähetä WhatsApp-testi-ilmoitus",
      "testWhatsAppLabel" : "WhatsApp-testi-ilmoitus (anna puhelinnumero maakoodin kanssa)",
      "testWhatsAppPlaceholder" : "+12345678901",
      "durationLabel" : "Milloin haluat käynnistää ilmoituksen lähettämisen?",
      "alertPhoneNumbers" : "Anna puhelinnumerot (maakoodien kanssa pilkuin eroteltuina)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Lisää muita",
      "afterAppointmentEnds" : "tapaamisen päättymisen jälkeen",
      "beforeAppointmentStarts" : "ennen tapaamisen alkamista",
      "templateLabel" : "WhatsApp-mallipohja",
      "templatePlaceholder" : "Valitse WhatsApp-mallipohja...",
      "noPreview" : "Mallipohjaa ei ole valittu",
      "templateRequired" : "Mallipohja on pakollinen",
      "testWhatsAppSuccessTitle" : "WhatsApp-testi-ilmoitus lähetetty!",
      "testWhatsAppSuccessDesc" : "WhatsApp-testi-ilmoitus on lähetetty numeroon {phone}",
      "testWhatsAppErrorTitle" : "WhatsApp-testi-ilmoituksen lähettäminen epäonnistui",
      "testWhatsAppErrorDesc" : "WhatsApp-testi-ilmoituksen lähettämisessä tapahtui virhe. Yritä uudelleen.",
      "setupTitle" : "Tavoita asiakkaat heidän suosikkiviestisovelluksessaan",
      "setupDescription" : "Pysy lähempänä asiakkaitasi tarjoamalla välitöntä tukea, lähettämällä oikea-aikaisia päivityksiä ja luomalla kiinnostavia vuorovaikutuksia.",
      "connectWhatsApp" : "Yhdistä WhatsApp",
      "checkingStatus" : "WhatsApp-tilin tilaa tarkistetaan...",
      "checkingTemplateStatus" : "WhatsApp-mallipohjan tilaa tarkastetaan...",
      "statusCheckError" : "WhatsApp-tilin tilan tarkistaminen epäonnistui",
      "templateStatusCheckError" : "WhatsApp-mallipohjan tilan tarkistaminen epäonnistui",
      "setupTemplateTitle" : "Suorita WhatsApp-mallipohjan määritys loppuun",
      "setupTemplateDescription" : "WhatsApp-mallipohjat on määritettävä, ennen kuin voit lähettää ilmoituksia. Viimeistele määritysprosessi napsauttamalla alla.",
      "loadTemplatesError" : "WhatsApp-mallipohjien lataus epäonnistui",
      "templatesRefreshed" : "Mallipohjat päivitetty",
      "templatesRefreshError" : "Mallipohjien päivittäminen epäonnistui",
      "templatesResolveError" : "WhatsApp-oletusmallipohjien ratkaisemisessa tapahtui virhe",
      "locationNotFound" : "Sijaintitunnusta ei löytynyt",
      "settingsRedirectError" : "Uudelleenohjaus WhatsApp-asetuksiin ei onnistu",
      "updateNotificationError" : "WhatsApp-ilmoituksen päivitys epäonnistui",
      "notificationsEnabled" : "WhatsApp-ilmoitukset käytössä!",
      "notificationsDisabled" : "WhatsApp-ilmoitukset poistettu käytöstä!",
      "updateError" : "Ilmoitusten päivittämisessä tapahtui virhe",
      "createNewTemplate" : "Luo uusi WhatsApp-mallipohja",
      "phoneValidation" : {
        "countryCodeRequired" : "Puhelinnumeron on alettava maakoodilla (esim. +1, +91 tai +44)",
        "digitsOnly" : "Puhelinnumeron tulee sisältää vain numeroita maakoodin jälkeen",
        "tooShort" : "Puhelinnumero on liian lyhyt",
        "tooLong" : "Puhelinnumero on liian pitkä",
        "invalid" : "Virheellinen puhelinnumero"
      },
      "errors" : {
        "templateNotFound" : "Mallipohjan tunnusta ei löytynyt ladatuista valinnoista, tyhjennetään",
        "templateNoLongerValid" : "Tallennettu mallipohja ei ole enää kelvollinen, tyhjennetään",
        "invalidTemplateSelection" : "Virheellinen WhatsApp-mallipohja yritettiin valita",
        "fetchingTemplates" : "WhatsApp-mallipohjien noutamisessa tapahtui virhe",
        "mountingCreator" : "WhatsApp-mallipohjatyökalun asennuksessa tapahtui virhe",
        "fetchingAfterCreation" : "WhatsApp-mallipohjien noutamisessa luomisen jälkeen tapahtui virhe",
        "updateStatus" : "WhatsApp-tilan päivityksessä tapahtui virhe"
      },
      "receiverLabels" : {
        "assignedUser" : "Määritetty käyttäjä",
        "phoneNumbers" : "Lisäpuhelinnumerot"
      }
    }
  },
  "smsTemplate" : {
    "create_new_template" : "Luo uusi SMS-mallipohja",
    "create_new_template_desc" : "Luo uudelleenkäytettävä SMS-mallipohja ilmoituksillesi",
    "template_name" : "Mallipohjan nimi",
    "template_name_placeholder" : "Syötä mallipohjan nimi",
    "message" : "Viesti",
    "message_placeholder" : "Kirjoita SMS-viesti tähän",
    "create_template" : "Luo mallipohja",
    "name_required" : "Mallipohjan nimi on pakollinen",
    "text_required" : "Viestiteksti on pakollinen",
    "fetch_new_templates" : "Päivitä mallipohjat"
  },
  "whatsappTemplate" : {
    "create_new_template" : "Luo uusi WhatsApp-mallipohja",
    "create_new_template_desc" : "Luo ilmoituksillesi uudelleenkäytettävä WhatsApp-mallipohja",
    "template_name" : "Mallipohjan nimi",
    "template_name_placeholder" : "Syötä mallipohjan nimi",
    "message" : "Viesti",
    "message_placeholder" : "Kirjoita WhatsApp-viestisi tähän",
    "create_template" : "Luo mallipohja",
    "name_required" : "Mallipohjan nimi on pakollinen",
    "text_required" : "Viestiteksti on pakollinen",
    "fetch_new_templates" : "Päivitä mallipohjat"
  },
  "archivedServices" : {
    "servicesBanner" : "Uusi, päivitetty Versio - Palvelut on tässä– tehokkaampi, joustavampi ja intuitiivisempi. Palvelukalenterisi on jo siirretty. Tutustu niihin nyt Palvelut- in .",
    "archivedServiceCalendars" : "Palvelukalenterit (v1)",
    "check_new_services" : "Ehdotusmerkki uusi Palvelut"
  },
  "tour" : {
    "hidden_test_label" : "Testaa",
    "calendar" : {
      "edit_calendar" : "Muokata kalenteria",
      "share_calendar" : "Jakaa kalenteri",
      "troubleshoot_calendar" : "Etsiä vika kalenterin vianetsintä",
      "more_options" : "Lisää Valinnat",
      "edit_calendar_desc" : "Hallinnoida kalenteriasetukset — Kiinteä, Määrittää Muistutus, Muokata Tapaaminenrajat ja paljon muuta.",
      "share_calendar_desc" : "Kopioida ja Jakaa Ajanvarauslinkkisi, jotta Buukkaaja voi helposti aikataulun Sinä/Te:n kanssa.",
      "troubleshoot_calendar_desc" : "Selvitä, miksi aikaväliä ei näy, ja katso mahdolliset syyt vianmääritysnäkymästä.",
      "more_options_desc" : "Pääsy lisäAsetukset ja toiminnot Hallinnoimaan kalenteriisi.",
      "read_permissions" : {
        "share_description" : "Anna muille käyttöoikeus jakamalla kalenterilinkki tai muokkaamalla käyttöoikeuksia.",
        "troubleshoot_description" : "Tunnista ja Ratkaise ongelmia, kuten synkronointivirheet tai puuttuvat tapahtumat, jotta toiminta on sujuvaa."
      },
      "next" : "Seuraava",
      "start_over" : "Aloita alusta",
      "all_set" : "vastaan Kokoelma!",
      "previous" : "Edellinen"
    }
  },
  "emailTemplate" : {
    "select_editing_experience" : "Valita muokkauskokemuksesi",
    "select_editing_experience_desc" : "Valita rakentamaan Kauttaan visuaalista vedä ja pudota -suunnittelueditorimme; toimittaja Tai Tehokas Koodieditori",
    "design_editor" : "Editori; toimittaja",
    "design_editor_desc" : "Visuaalinen, Vetää ja pudota -muokkaus.",
    "code_editor" : "Koodieditori",
    "code_editor_desc" : "Ominaisuudet-Rikas HTML muokkaus.",
    "text_editor" : "Tavallinen Koodieditori",
    "text_editor_desc" : "Yksinkertainen, Puhdas, yksinkertainen Runko Editointi.",
    "email_text_block" : "Sähköposti voi olla myös Luotu Kautta Runko Block. ",
    "select" : "Valita",
    "new_template" : "uusi Mallipohja",
    "email_block" : "Sähköposti voi olla myös Luotu Kautta Runko Block.",
    "fetch_new_templates" : "Hae uudet mallipohjat"
  },
  "quick_tips" : {
    "meeting_details" : {
      "include_contact_and_user_names" : "Jos haluat sisällyttää sekä kontaktin nimen että tapaamisen käyttäjän nimen kokouksen otsikkoon, käytä seuraavaa muotoa: &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url" : "Jotta pääsy ei keskeytyisi, lisää mukautettu kokous-URL varavaihtoehtona siltä varalta, että Zoom- tai Gmeet-integraatioissa ilmenee ongelmia.",
      "enable_gmeet_primary" : "Vot ottaa Gmeet-toiminnon käyttöön varmistamalla, että tiimin jäsenen Google-kalenteri on asetettu ensisijaiseksi kalenteriksi asetuksissa."
    },
    "availability" : {
      "twenty_four_hours" : "Jos haluat, että kalenteri on käytettävissä 24 tuntia vuorokaudessa, aseta aikaväliksi 0.00–0.00.",
      "update_timezone_preferences" : "Aikavyöhykkeitä voi muuttaa milloin tahansa valikossa Yritysprofiili >> Aikavyöhykeasetukset.",
      "service_calendar_slot_interval" : "Määritä palvelukalenteriisi saatavuus ja oletusarvoisesti 15 minuutin väli tapaamisten välille."
    },
    "forms" : {
      "create_custom_forms" : "Voit luoda helposti mukautettuja lomakkeita markkinointiosion kohdassa Lomakkeet ja integroida ne saumattomasti kalentereihin järjestelmällisen tiedonkeruun varmistamiseksi.",
      "apply_sticky_contacts" : "Kun sisällytät mukautetun lomakkeen, paikallaan pysyvä kontaktien asetukset, joka on linkitetty lomakkeeseen, otetaan käyttöön automaattisesti.",
      "use_custom_values" : "Voit sisällyttää Mukautetut arvot ja Kentät yhteystiedoista sekä lomakkeen viestiin että lomakkeen URL-osoitteeseen."
    },
    "notifications" : {
      "use_workflows" : "Edistyneitä ilmoituksia varten käytä työnkulkuja tai tapaamisen varattuja laukaisimia."
    },
    "customizations" : {
      "update_widget_language" : "Voit muuttaa widgetin kieliasetuksia seuraavasti: Asetukset >> Kalenterit >> Asetukset >> Tiliasetukset."
    },
    "equipments" : {
      "room_definition" : "”Huone” voi edustaa mitä tahansa sijaintia, jossa palvelut on julkaistu. Tämä voi olla fyysisiä huoneita ja/tai erillisiä asemia. Esim.: pedikyyriasema.",
      "equipment_definition" : "Ajattele \"laitteita\" minä tahansa työkaluna tai laitteena, jota yritykset käyttävät tapaamisten täyttämiseen. Tämä voi sisältää koneita, laitteita tai jopa tuoleja."
    }
  },
  "aria_labels" : {
    "sticky_contacts" : "Tallennetut kontaktit",
    "consent_form" : "Hyväksyntälomake",
    "enable_guests" : "Ota vieraat käyttöön",
    "auto_confirm" : "Automaattinen vahvistus",
    "should_accept_payment" : "Maksu tulisi hyväksyä",
    "collect_deposit" : "Kerää varausmaksu",
    "enable_charge_guests" : "Ota vieraiden veloitus käyttöön",
    "enable_coupon" : "Ota kuponki käyttöön",
    "payment_live" : "Reaaliaikainen maksu",
    "add_availability_hour" : "Lisää saatavuustunti",
    "remove_availability_hour" : "Poista saatavuustunti",
    "copy_availability_hour" : "Kopioi saatavuustunti",
    "close_modal" : "Sulje modaali",
    "add_custom_slot" : "Lisää mukautettu aikaväli",
    "remove_custom_slot" : "Poista mukautettu aikaväli",
    "edit_custom_slot" : "Muokkaa mukautettua aikaväliä",
    "update_frequency" : "Päivittää esiintymistaajuus",
    "show_calendar_title" : "Näytä kalenterin otsikko",
    "show_calendar_description" : "Näytä kalenterin kuvaus",
    "show_calendar_details" : "Näytä kalenteritiedot",
    "allow_reschedule" : "Salli ajankohdan siirto",
    "allow_cancellation" : "Salli peruutus",
    "category_actions" : "Kategoria-toiminnot"
  },
  "placeholders" : {
    "pixel_id" : "Pikselin tunnus",
    "select_one" : "Valitse yksi",
    "meeting_location" : "Tapaamispaikka",
    "schedule_meeting" : "Aikatauluta kokous",
    "notes" : "Muistiinpanot",
    "select_users" : "Valitse käyttäjät"
  },
  "alt_text" : {
    "payment_provider" : "Maksupalveluntarjoaja",
    "no_calendars" : "Ei kalentereita",
    "date_specific_hours" : "päivämääräkohtaiset tunnit",
    "custom_widget_image" : "Mukautettu widget-kuva",
    "service_calendar" : "Palvelukalenteri",
    "event_calendar" : "Tapahtumakalenteri",
    "round_robin_booking" : "Round Robin -varaus",
    "class_booking" : "Luokan varaus",
    "collective_booking" : "Kollektiivinen varaus"
  },
  "tooltips" : {
    "text_color" : "Tekstin väri",
    "background_color" : "Taustaväri",
    "strikethrough" : "Yliviivaus",
    "superscript" : "Yläindeksi",
    "subscript" : "Alaindeksi",
    "inline_code_block" : "Sisäinen koodilohko",
    "code_block" : "Koodilohko",
    "block_quote" : "Lainauslohko",
    "more" : "Lisää",
    "upload" : "Lataa"
  },
  "labels" : {
    "reset_style" : "Nollaa tyyli",
    "reset_document_style" : "Nollaa asiakirjan tyyli",
    "source_code" : "Lähdekoodi",
    "success" : "Onnistui",
    "edit" : "Muokkaa",
    "submit" : "Lähetä",
    "cancel" : "Peruuta",
    "payment" : "Maksu",
    "here_is_the_link" : "Tässä on linkki:",
    "here_is_the_embed_code" : "Tässä on upotettu koodi:",
    "service_calendar" : "Palvelukalenteri",
    "collective_booking" : "Kollektiivinen varaus",
    "class_booking" : "Luokan varaus",
    "round_robin_booking" : "Round Robin -varaus",
    "event_calendar" : "Tapahtumakalenteri",
    "personal_booking" : "Henkilökohtainen varaus",
    "service_booking" : "Palveluvaraus"
  },
  "validation_messages" : {
    "calendar_group_name_required" : "Kalenteriryhmän nimi on pakollinen",
    "calendar_group_description_required" : "Kalenteriryhmän kuvaus on pakollinen",
    "slug_required" : "Kestolinkki tarvitaan",
    "slug_not_valid" : "Tämä kestolinkki ei ole kelvollinen",
    "slug_already_taken" : "Tämä kestolinkki on jo käytössä",
    "error_validating_slug" : "Kestolinkin validointivirhe",
    "please_enter_name" : "Kirjoita nimi",
    "room_name_required" : "Huoneen nimi on pakollinen",
    "equipment_name_required" : "Laitteen nimi on pakollinen",
    "subject_required" : "Aihe on pakollinen",
    "this_is_required" : "Tämä on pakollinen",
    "calendar_group_slug_required" : "Kalenteriryhmän kestolinkki on pakollinen",
    "capacity_mandatory" : "Kapasiteetti on pakollinen",
    "capacity_cannot_be_zero" : "Kapasiteetti ei voi olla nolla",
    "capacity_should_be_a_number" : "Kapasiteetin pitää olla luku",
    "capacity_cannot_be_negative" : "Kapasiteetti ei voi olla negatiivinen",
    "capacity_should_be_a_whole_number" : "Kapasiteetin on oltava kokonaisluku",
    "quantity_mandatory" : "Määrä on pakollinen",
    "quantity_cannot_be_zero" : "Määrä ei voi olla nolla",
    "quantity_should_be_a_number" : "Määrän tulee olla luku",
    "quantity_cannot_be_negative" : "Määrä ei voi olla negatiivinen",
    "quantity_should_be_a_whole_number" : "Määrän tulee olla kokonaisluku",
    "quantity_cannot_be_less_than_out_of_service_equipments" : "Määrä ei voi olla pienempi kuin käytöstä poistettujen laitteiden määrä.",
    "out_of_service_value_should_be_a_number" : "Poistettu käytöstä -arvo pitää olla luku",
    "out_of_service_cannot_be_negative" : "Poistettu käytöstä ei voi olla negatiivinen",
    "out_of_service_equipments_qty" : "Käytöstä poistettujen laitteiden määrä ei saa ylittää todellista laitemäärää",
    "out_of_service_whole_number" : "Poistettu käytöstä pitää olla kokonaisluku",
    "slot_duration_required" : "Aikavälin kesto on pakollinen",
    "slot_duration_integer" : "Aikavälin keston pitää olla kokonaisluku",
    "meeting_duration_validation" : "Kokouksen keston on oltava yhden minuutin ja 12 tunnin välillä",
    "seats_class_required" : "Paikat per luokka vaaditaan",
    "seats_class_integer" : "Paikat per luokka pitää olla kokonaisluku",
    "seats_class_validation" : "Tämä ei voi olla suurempi kuin 9 999 tai pienempi kuin 0",
    "meeting_location_required" : "Tapaamispaikka on pakollinen"
  },
  "custom_values" : {
    "assigned_user" : "Määritetty käyttäjä",
    "full_name" : "Koko nimi",
    "first_name" : "Etunimi",
    "last_name" : "Sukunimi",
    "email" : "Sähköposti",
    "phone" : "Puhelin",
    "twilio_phone" : "Twilio-puhelin",
    "account" : "Tili",
    "name" : "Nimi",
    "full_address" : "Koko osoite",
    "city" : "Kaupunki",
    "state" : "Osavaltio",
    "country" : "Maa",
    "postal_code" : "Postinumero",
    "contact" : "Kontakti",
    "address1" : "Osoite 1",
    "timezone" : "Aikavyöhyke",
    "user" : "Käyttäjä",
    "appointment" : "Tapaaminen",
    "start_date_time" : "Aloituspäivämäärä",
    "start_date" : "Alkamispäivä",
    "start_time" : "Alkamisaika",
    "end_date_time" : "Päättymispäivämäärä",
    "end_date" : "Päättymispäivä",
    "end_time" : "Päättymisaika",
    "meeting_location" : "Tapaamispaikka"
  },
  "meeting_location_types" : {
    "zoom" : "Zoom",
    "google_meet" : "Google Meet",
    "phone" : "Puhelin",
    "full_address" : "Koko osoite",
    "microsoft_teams" : "Microsoft Teams",
    "custom" : "Mukautettu"
  },
  "duration_units" : {
    "minutes" : "Minuutit",
    "hours" : "Tunnit"
  },
  "widget_styles" : {
    "classic" : "Klassinen",
    "neo" : "Neo"
  },
  "feature_labels" : {
    "service_menu" : "Palveluvalikko",
    "rooms" : "Huoneet",
    "equipments" : "Laitteet"
  },
  "lsa" : {
    "categories" : {
      "accountant" : "Kirjanpito",
      "acupuncturist" : "Akupunktio",
      "air_duct_cleaner" : "Ilmakanavien puhdistus",
      "alcohol_treatment" : "Alkoholismin hoitopalvelut",
      "animal_shelter" : "Eläinten pelastuspalvelut",
      "appliance_repair" : "Laitteiden korjaus",
      "architect" : "Arkkitehtuuri",
      "assisted_living" : "Avustetut asumispalvelut",
      "babysitter" : "Lastenvahti",
      "bankruptcy_lawyer" : "Konkurssioikeus",
      "beauty_school" : "Kauneuskoulu",
      "business_lawyer" : "Liiketoimintalaki",
      "car_repair" : "Automaattiset palvelut",
      "carpenter" : "Puusepäntyö",
      "carpet_cleaning" : "Matonpesu",
      "child_care" : "Lastenhoitopalvelut",
      "chiropractor" : "Kiropraktiikkapalvelut",
      "cleaning_service" : "Talon siivous",
      "contract_lawyer" : "Sopimusoikeus",
      "countertop_pro" : "Työtasopalvelut",
      "criminal_lawyer" : "Rikosoikeus",
      "dance_instructor" : "Tanssiopetus",
      "disability_lawyer" : "Vammaislainsäädäntö",
      "driving_instructor" : "Ajo-koulutus",
      "dui_lawyer" : "Rattijuopumuslaki",
      "electrician" : "Sähköinen",
      "energy_efficiency_pro" : "Energiatehokkuuspalvelut",
      "estate_lawyer" : "Kiinteistölaki",
      "event_planner" : "Tapahtumasuunnittelu",
      "family_lawyer" : "Perheoikeus",
      "fencing_pro" : "Aitaus",
      "financial_planner" : "Taloussuunnittelu",
      "first_aid_trainer" : "Ensiapukoulutus",
      "flooring_pro" : "Lattiapäällysteet",
      "foundation_pro" : "Perusteet",
      "funeral_home" : "Hautauspalvelut",
      "garage_door_pro" : "Autotallin ovi",
      "general_contractor" : "Kodinsisustus",
      "handyman" : "Yleismies",
      "home_inspector" : "Kodintarkastus",
      "home_security" : "Kodin turvallisuuspalvelut",
      "home_theater" : "Kotiteatteripalvelut",
      "hvac" : "LVI-järjestelmät",
      "immigration_lawyer" : "Maahanmuuttolainsäädäntö",
      "interior_designer" : "Sisustussuunnittelu",
      "ip_lawyer" : "Immateriaalioikeuslaki",
      "junk_removal" : "Romun poisto",
      "labor_lawyer" : "Työlainsäädäntö",
      "landscaper" : "Maisema-arkkitehtuuri",
      "language_instructor" : "Kieliopetus",
      "lawn_care" : "Nurmikon hoito",
      "litigation_lawyer" : "Oikeudenkäyntilainsäädäntö",
      "locksmith" : "Lukkoseppä",
      "malpractice_lawyer" : "Hoitovirhelaki",
      "massage_center" : "Hierontapalvelut",
      "massage_school" : "Hierontakoulu",
      "mover" : "Muuttopalvelu",
      "nursing_home" : "Hoitokotipalvelu",
      "painter" : "Maalaus",
      "personal_injury_lawyer" : "Henkilövahinkolaki",
      "personal_trainer" : "Henkilökohtainen valmennus",
      "pest_control" : "Tuholaistorjunta",
      "pet_adoption" : "Lemmikkien adoptiopalvelut",
      "pet_boarding" : "Lemmikkien majoitus",
      "pet_grooming" : "Lemmikkien trimmaus",
      "pet_trainer" : "Lemmikkien koulutus",
      "photographer" : "Valokuvaus",
      "plumber" : "Putkityöt",
      "pool_cleaner" : "Altaan puhdistus",
      "pool_contractor" : "Uima-allasurakointi",
      "preschool" : "Esikoulu",
      "psychologist" : "Psykologiapalvelut",
      "real_estate_agent" : "Kiinteistöala",
      "real_estate_lawyer" : "Kiinteistölaki",
      "rehab" : "Kuntoutuspalvelut",
      "roofer" : "Kattotyöt",
      "sewage_pro" : "Viemärijärjestelmäpalvelut",
      "siding_pro" : "Ulkoverhous",
      "smart_home" : "Älykkodin palvelut",
      "snow_removal" : "Lumenaurauspalvelut",
      "spa" : "Kylpyläpalvelut",
      "tax_lawyer" : "Verolainsäädäntö",
      "tax_specialist" : "Veropalvelut",
      "therapist" : "Terapia",
      "towing_pro" : "Tiepalvelu",
      "traffic_lawyer" : "Liikennelaki",
      "tree_service" : "Puunhoitopalvelut",
      "tutor" : "Opetus",
      "upholstery_cleaner" : "Verhoilun puhdistus",
      "veterinarian" : "Eläinlääkäripalvelut",
      "videographer" : "Videopalvelut",
      "water_damage" : "Vesivahinkopalvelut",
      "weight_loss_service" : "Painonpudotuspalvelut",
      "window_cleaner" : "Ikkunoiden pesu",
      "window_repair" : "Ikkunapalvelut",
      "windshield_repair_pro" : "Autolasi",
      "yoga_instructor" : "Jooga"
    },
    "job_types" : {
      "accountant_other" : "Muu",
      "bankruptcy_tax_litigation" : "Konkurssivero-oikeudenkäynti",
      "bookkeeping" : "Kirjanpito",
      "business_consulting" : "Yrityskonsultointi",
      "debt_collection_relief" : "Velkojen perinnän helpotus",
      "irs_representation_resolution" : "IRS:n edustus ja ratkaisut",
      "payroll" : "Palkkalista",
      "tax_planning_business" : "Yrityksen verosuunnittelu",
      "tax_planning_individual" : "Yksityishenkilön verosuunnittelu",
      "tax_return_business" : "Yrityksen veroilmoitus",
      "tax_return_individual" : "Yksityisen veroilmoitus",
      "trusts_estates_accounting" : "Luottamusomaisuuden kirjanpito",
      "acupressure" : "Akupainanta",
      "acupuncture" : "Akupunktio",
      "acupuncturist_other" : "Muu",
      "cupping" : "Kuppaus",
      "gua_sha" : "Gua Sha",
      "heat_therapy" : "Lämpöhoito",
      "herbal_therapy" : "Yrttiterapia",
      "infrared_therapy" : "Infrapunaterapia",
      "moxibustion" : "Moksibustio",
      "qigong" : "Qigong",
      "shiatsu" : "Shiatsu",
      "tui_na" : "Tui Na",
      "air_duct_cleaning" : "Ilmakanavien puhdistus",
      "air_duct_filter_replacement" : "Suodattimen vaihto",
      "air_duct_other" : "Muu",
      "dryer_vent_cleaning" : "Kuivausrummun tuuletusaukon puhdistus",
      "furnace_cleaning" : "Uunin puhdistus",
      "indoor_air_quality_testing" : "Sisäilman laadun testaus",
      "alcohol_treatment_other" : "Muu",
      "animal_shelter_cat_adoption" : "Kissan adoptio",
      "animal_shelter_dog_adoption" : "Koiran adoptio",
      "animal_shelter_other" : "Muu",
      "animal_shelter_other_animal_adoption" : "Muun eläimen adoptio",
      "animal_shelter_other_veterinary_services" : "Muut eläinlääkintäpalvelut",
      "animal_shelter_spay_neuter" : "Sterilointi tai kastrointi",
      "animal_shelter_vaccinations" : "Rokotukset",
      "lost_stray_found_animals" : "Menetetyt, eksyneet tai löydetyt eläimet",
      "pet_license" : "Lemmikkilupa",
      "pet_surrender" : "Lemmikin luovutus",
      "appliance_other" : "Muu",
      "repair_dishwasher" : "Astianpesukoneen korjaus",
      "repair_dryer" : "Kuivaimen korjaus",
      "repair_freezer" : "Pakastimen korjaus",
      "repair_microwave" : "Mikroaaltouunin korjaus",
      "repair_oven" : "Uunin korjaus",
      "repair_refrigerator" : "Jääkaapin korjaus",
      "repair_refrigerator_freezer" : "Jääkaapin / pakastimen korjaus",
      "repair_stove_cooktop" : "Lieden / keittotason korjaus",
      "repair_stove_cooktop_oven" : "Lieden / keittotason / uunin korjaus",
      "repair_washer" : "Pesukoneen korjaus",
      "repair_washer_dryer" : "Pesukoneen / kuivausrummun korjaus",
      "3d_architectural_rendering" : "3D-arkkitehtuurinen visualisointi",
      "adaptive_reuse_historical_renovation" : "Mukauttava uudelleenkäyttö ja historiallinen peruskorjaus",
      "architect_other" : "Muu",
      "architectural_designing" : "Rakennussuunnittelu",
      "architectural_engineering" : "Rakennustekniikka",
      "building_code_analysis_permit_coordination" : "Koodianalyysi ja luvat",
      "consulting" : "Konsultointi",
      "home_building_improvement" : "Kodinrakennus ja -parannus",
      "interior_design_architect" : "Sisustussuunnittelu",
      "planning_zoning_approval_assistance" : "Suunnittelu ja kaavoituslupa",
      "project_managing_architect" : "Projektinhallinta",
      "site_master_planning" : "Sivuston pääsuunnittelu",
      "assisted_living_housekeeping_and_laundry" : "Siivous ja pyykkipalvelut",
      "assisted_living_meal_services" : "Ateriapalvelut",
      "assisted_living_memory_care" : "Muistisairauksien hoito",
      "assisted_living_other" : "Muu",
      "assisted_living_rehabilitation_services" : "Kuntoutuspalvelut",
      "assisted_living_transportation" : "Liikenne",
      "assisted_living_wellness_programs" : "Hyvinvointiohjelmat",
      "daily_living_assistance" : "Päivittäinen elämänhallinta-apu",
      "medication_management" : "Lääkkeiden hallinta",
      "short_term_stays" : "Lyhyet oleskelut",
      "social_and_recreational_activities" : "Virkistystoiminta",
      "babysitter_other" : "Muu",
      "event_babysitting" : "Lastenhoito tapahtumien aikana",
      "homework_assistance" : "Läksyapu",
      "housekeeping_laundry" : "Siivous ja pyykkipalvelut",
      "meal_preparation" : "Aterian valmistelu",
      "nanny_services" : "Lastenhoitopalvelut",
      "overnight_babysitting" : "Yön yli tapahtuva lastenhoito",
      "pick_up_and_drop_off" : "Nouto ja palautus",
      "shopping_errand" : "Ostokset ja asiointi",
      "special_needs_care" : "Vammaisten hoito",
      "virtual_babysitting" : "Virtuaalinen lastenhoito",
      "agriculture_bankruptcy" : "Maatalousalan konkurssi",
      "bankruptcy_lawyer_other" : "Muu",
      "bankruptcy_litigation" : "Konkurssioikeudenkäynti",
      "chapter_11_bankruptcy" : "Luku 11 -konkurssi",
      "chapter_13_bankruptcy" : "Luku 13 velkajärjestely",
      "chapter_7_bankruptcy" : "Luku 7 konkurssi",
      "corporate_bankruptcy" : "Yrityksen konkurssi",
      "creditor_harassment" : "Velkojan häirintä",
      "debt_settlement" : "Velkajärjestely",
      "foreclosure_bankruptcy_lawyer" : "Ulosmittaus",
      "personal_bankruptcy" : "Henkilökohtainen konkurssi",
      "repossession" : "Takaisinsaanti",
      "wage_garnishment" : "Palkan ulosmittaus",
      "beauty_school_barbering" : "Parturipalvelut",
      "beauty_school_business_management" : "Liiketoiminnan johtaminen",
      "beauty_school_cosmetology" : "Kosmetologia",
      "beauty_school_esthetics" : "Estetiikka",
      "beauty_school_hair_cutting" : "Hiustenleikkaus",
      "beauty_school_hair_design" : "Hiussuunnittelu",
      "beauty_school_makeup" : "Meikki",
      "beauty_school_massage_therapy" : "Hierontaterapia",
      "beauty_school_nail_technology" : "Kynsiteknologia",
      "beauty_school_other" : "Muu",
      "beauty_school_retail_training" : "Vähittäiskaupan kurssit",
      "banking_finance_law" : "Pankki- ja rahoitusala",
      "business_lawyer_other" : "Muu",
      "business_licenses_permits" : "Liiketoimintaluvat",
      "business_litigation" : "Liike-elämän oikeudenkäynnit",
      "business_taxes" : "Yritysverot",
      "business_transactions_business_lawyer" : "Liiketoimet",
      "commercial_bankruptcy" : "Kaupallinen konkurssi.",
      "commercial_contracts_business_lawyer" : "Kaupalliset sopimukset",
      "employment_law_business_lawyer" : "Työlainsäädäntö",
      "incorporation_restructuring" : "Yhtiöittäminen & uudelleenjärjestely",
      "insurance_law" : "Vakuutuslaki",
      "intellectual_property_law" : "Immateriaalioikeuslaki",
      "mergers_acquisitions_business_lawyer" : "Sulautumiset ja yrityskaupat",
      "partnership_agreements_business_lawyer" : "Kumppanuussopimukset",
      "patents_copyrights_trademarks" : "Patentit, tekijänoikeudet ja tavaramerkit",
      "securities_law" : "Arvopaperilaki",
      "shareholder_disputes" : "Osakkeenomistajien kiistat",
      "air_and_cabin_filter" : "Ilma- ja matkustamosuodatin",
      "battery" : "Akku",
      "body_and_trim" : "Kori ja verhoilu",
      "brakes" : "Jarrut",
      "car_air_conditioning" : "Ilmastointi",
      "car_electrical" : "Sähköinen",
      "car_repair_other" : "Muu",
      "check_engine_light_diagnostic" : "Tarkista moottorin merkkivalon diagnostiikka",
      "exhaust" : "Pakokaasu",
      "oil_change" : "Öljynvaihto",
      "steering_suspension" : "Ohjaus/jousitus",
      "tires" : "Renkaat",
      "transmission" : "Vaihteisto",
      "cabinetry" : "Kaapistot",
      "carpenter_other" : "Muu",
      "decking" : "Terassilaudoitus",
      "drywalling" : "Kipsilevytys",
      "fencing" : "Aitaus",
      "general_installations" : "Yleiset asennukset",
      "general_repairs_maintenance" : "Yleiset korjaukset ja huolto",
      "remodeling" : "Uudistaminen",
      "shelving_storage" : "Hyllyt ja varastointi",
      "carpet_cleaning_other" : "Muu",
      "clean_area_rugs" : "Puhdista aluematot",
      "clean_carpet" : "Maton puhdistus",
      "clean_drapes_and_curtains" : "Puhdista verhot ja kappa",
      "clean_upholstery" : "Verhoilun puhdistus",
      "remove_pet_stains_and_odors" : "Lemmikkien tahrojen ja hajujen poistaminen",
      "after_school_care" : "Koululaisten iltapäivähoito",
      "all_hours_daycare" : "Ympärivuorokautinen päivähoito",
      "bilingual_daycare" : "Kaksikielinen päivähoito",
      "child_care_other" : "Muu",
      "drop_in_daycare" : "Päivähoito ilman ajanvarausta",
      "full_time_daycare" : "Kokopäivähoito",
      "in_home_daycare" : "Kotipäivähoito",
      "infant_programs" : "Vauvaohjelmat",
      "part_time_daycare" : "Osa-aikainen päivähoito",
      "pre_kindergarten_programs" : "Esikouluohjelmat",
      "preschool_programs" : "Esikouluohjelmat",
      "school_age_programs" : "Kouluikäisten ohjelmat",
      "special_needs_daycare" : "Vammaisten päivähoito",
      "summer_daycare" : "Kesäpäivähoito",
      "toddler_programs" : "Taapero-ohjelmat",
      "weekend_daycare" : "Päivähoito viikonloppuna",
      "chiropractor_acupuncture" : "Akupunktio",
      "chiropractor_chiropractic" : "Kiropraktiikka",
      "chiropractor_massage_therapy" : "Hierontaterapia",
      "chiropractor_other" : "Muu",
      "diagnosis" : "Diagnosointi",
      "eastern_medicine" : "Itämainen lääketiede",
      "exercise_counseling" : "Liikuntaneuvonta",
      "pain_management" : "Kivunhallinta",
      "physical_therapy" : "Fysioterapia",
      "spinal_adjustments" : "Selkärangan säätö",
      "sports_medicine" : "Urheilulääketiede",
      "cleaner_other" : "Muu",
      "deep_clean" : "Syväpuhdistus",
      "moving_clean" : "Muuttosiivous",
      "office_clean" : "Toimiston siivous",
      "standard_clean" : "Vakiopuhdistus",
      "assignment_of_contract" : "Sopimuksen siirto",
      "business_transactions_contract_lawyer" : "Liiketoimet",
      "commercial_contracts_contract_lawyer" : "Kaupalliset sopimukset",
      "contract_dispute" : "Sopimusriita",
      "contract_lawyer_other" : "Muu",
      "contract_negotiation" : "Sopimusneuvottelu",
      "contract_review" : "Sopimusten tarkistus",
      "employment_contracts_contract_lawyer" : "Työsopimukset",
      "franchise_agreements" : "Franchising-sopimukset",
      "mergers_acquisitions_contract_lawyer" : "Sulautumiset ja yrityskaupat",
      "non_disclosure_agreements_contract_lawyer" : "Salassapitosopimukset",
      "partnership_agreements_contract_lawyer" : "Kumppanuussopimukset",
      "power_of_attorney_contract_lawyer" : "Valtakirja valtuutus",
      "security_agreements" : "Turvallisuussopimukset",
      "warranties" : "Takuut",
      "bathroom_countertops" : "Kylpyhuoneen työtasot",
      "bathroom_wall_panels" : "Kylpyhuoneen seinäpaneelit",
      "countertop_design" : "Työtason muotoilu",
      "countertop_installation" : "Työtason asennus",
      "countertop_pro_other" : "Muu",
      "fireplace_facade" : "Takan julkisivu",
      "granite_countertops" : "Graniittitasot",
      "kitchen_countertops" : "Keittiön työtasot",
      "kitchen_wall_panels" : "Keittiön seinäpaneelit",
      "laminate_countertops" : "Laminaattityötasot",
      "marble_countertops" : "Marmorityötasot",
      "quartz_countertops" : "Kvartsityötasot",
      "remodeling_countertop_pro" : "Uudistaminen",
      "repair_maintenance_countertop_pro" : "Korjaus ja ylläpito",
      "stone_slab_countertops" : "Kivilaattojen työtasot",
      "tile_countertops" : "Laattatyötasot",
      "corporate_representation" : "Yritysten edustus",
      "criminal_immigration_defense" : "Rikokseen syyllistyneiden maahanmuuttajien puolustus",
      "criminal_lawyer_other" : "Muu",
      "domestic_violence" : "Perheväkivalta",
      "drug_possession" : "Huumausaineiden hallussapito",
      "duis_reckless_driving" : "Rattijuopumukset ja holtiton ajaminen",
      "expungement" : "Poistaminen",
      "federal_crimes" : "Liittovaltion rikokset",
      "felonies" : "Rikokset",
      "petty_crimes_misdemeanors" : "Pikkurikokset ja rikkomukset",
      "restraining_orders" : "Lähestymiskiellot",
      "sex_offenses" : "Seksuaalirikokset",
      "three_strikes_law" : "Kolmen rikkomuksen laki",
      "dance_instructor_african" : "Afrikkalainen",
      "dance_instructor_ballet" : "Baletti",
      "dance_instructor_ballroom" : "Tanssisali",
      "dance_instructor_belly" : "Vatsa",
      "dance_instructor_bollywood" : "Bollywood",
      "dance_instructor_contemporary" : "Nykyaikainen",
      "dance_instructor_folk_traditional" : "Kansanmusiikki ja klassinen",
      "dance_instructor_hip_hop" : "Hip hop",
      "dance_instructor_jazz" : "Jazz",
      "dance_instructor_kids_classes" : "Lasten kurssit",
      "dance_instructor_latin" : "Latina",
      "dance_instructor_modern" : "Moderni",
      "dance_instructor_other" : "Muu",
      "dance_instructor_tap" : "Napauta",
      "dance_instructor_wedding" : "Häät",
      "disability_hearings" : "Vammaisasioihin liittyvät kuulemiset",
      "disability_lawyer_other" : "Muu",
      "long_term_disability" : "Pitkäaikainen vammaisuus",
      "short_term_disability" : "Lyhytaikainen työkyvyttömyys",
      "social_security_disability_insurance" : "Sosiaalinen työkyvyttömyysvakuutus",
      "ssa_claim_reconsideration" : "SSA:n hakemuksen uudelleentarkastelu",
      "ssa_disability_appeals" : "SSA:n vammaisvalitukset",
      "ssa_disability_applications" : "SSA:n vammaishakemukset",
      "ssa_disability_benefits" : "SSA:n työkyvyttömyysetuudet",
      "ssa_family_benefits" : "SSA:n perhe-etuudet",
      "ssa_impairment_listings" : "SSA arvonalentumisluettelot",
      "supplemental_security_income" : "Täydentävä sosiaalituki",
      "veterans_disability_benefits" : "Veteraanien vammaisetuudet",
      "workers_compensation_disability_lawyer" : "Työntekijöiden korvaukset",
      "behind_the_wheel_lessons" : "Ratin takana -oppitunnit",
      "commercial_license_training" : "Kaupallisen lisenssin kurssit",
      "defensive_driving_lessons" : "Puolustavan ajamisen oppitunnit",
      "drivers_education_classes" : "Kuljettajakoulutuskurssit",
      "driving_instructor_other" : "Muu",
      "manual_transmission_lessons" : "Manuaalivaihteiston oppitunti",
      "motorcycle_lessons" : "Moottoripyöräoppitunnit",
      "traffic_school" : "Liikennekoulu",
      "dui_dwi_dui_lawyer" : "DUI/DWI",
      "dui_injuries_dui_lawyer" : "Rattijuopumus ja vamma",
      "dui_lawyer_other" : "Muu",
      "dui_with_accident" : "Rattijuopumus ja onnettomuus",
      "felony_dui" : "Törkeä rattijuopumus",
      "invalid_tests" : "Virheelliset testit",
      "multiple_offenses" : "Useita rikkomuksia",
      "reckless_driving_dui_lawyer" : "Holtiton ajo",
      "underage_dui" : "Alaikäisen rattijuopumus",
      "electric_car_charger" : "Asenna sähköauton laturi",
      "electrician_other" : "Muu",
      "electrician_remodeling" : "Uudistaminen",
      "install_fan" : "Asenna tuuletin",
      "install_ground_wire" : "Asenna maadoitusjohto",
      "install_light_fixtures" : "Asenna valaisimet",
      "install_outdoor_lighting" : "Asentaa ulkovalaistus",
      "install_outlets_switches" : "Asentaa pistorasiat tai kytkimet.",
      "install_security_system" : "Asenna turvajärjestelmä",
      "relocate_outlets_switches" : "Pistorasioiden ja kytkimien siirtäminen",
      "repair_fan" : "Tuuletttimen korjaus",
      "repair_light_fixtures" : "Valaisimien korjaus",
      "repair_outlets_switches" : "Korjaa pistorasiat tai kytkimet",
      "repair_panel" : "Korjaa paneeli",
      "replace_upgrade_panel" : "Korvaa tai päivittä paneeli",
      "restore_power" : "Palauta virta",
      "energy_efficiency_pro_other" : "Muu",
      "charitable_giving" : "Hyväntekeväisyyslahjoitukset",
      "contests_litigation" : "Kilpailut / riidat",
      "deeds" : "Asiakirjat",
      "estate_lawyer_other" : "Muu",
      "estate_planning_lawyer" : "Perintösuunnittelu",
      "guardianship_estate_lawyer" : "Huoltajuus",
      "medical_power_of_attorney" : "Lääketieteellinen valtuutus",
      "power_of_attorney_estate_lawyer" : "Valtakirja",
      "probate_estate_lawyer" : "Perintöasioiden lakimies",
      "trusts" : "Säätiöt",
      "wills" : "Testamentit",
      "anniversary_planner" : "Vuosipäivä",
      "baby_shower_planner" : "Vauvajuhlat",
      "bar_and_bat_mitzvah_planner" : "Bar ja Bat Mitzvah",
      "birthday_party" : "Syntymäpäiväjuhla",
      "children_party" : "Lasten juhlat",
      "corporate_and_conference_planner" : "Yritys ja konferenssi",
      "event_planner_other" : "Muu",
      "quinceanera_planner" : "50-vuotisjuhlat",
      "religious_event" : "Uskonnollinen tapahtuma",
      "retirement_party" : "Eläkkeelle jäämisjuhlat",
      "school_event" : "Koulun tapahtuma",
      "theme_party" : "Teemajuhla",
      "wedding_and_engagement_planner" : "Häät ja kihlaus",
      "adoption" : "Adoptio",
      "child_support" : "Lapsen elatusapu",
      "contested_divorce" : "Riidanalainen avioero",
      "debt_division" : "Velkojen jakaminen",
      "family_lawyer_other" : "Muu",
      "guardianship_family_lawyer" : "Huoltajuus",
      "mediation_family_lawyer" : "Välitys",
      "modifications_of_orders" : "Tilausten muokkaus",
      "parent_timesharing" : "Vanhempien yhteishuoltajuus",
      "paternity" : "Isyys",
      "prenuptial_postnuptial_agreements" : "Avioehdot ja avioliittosopimukset",
      "probate_family_lawyer" : "Perunkirjoitus",
      "property_divisions" : "Omaisuuden jako",
      "protective_orders_domestic_violence_issues" : "Lähestymiskiellot",
      "spousal_support_alimony" : "Puolison elatusapu ja avioerokorvaus",
      "uncontested_divorce" : "Riidaton avioero",
      "custom_construction" : "Mukautettu rakentaminen",
      "fence_design" : "Aidan suunnittelu",
      "fencing_other" : "Muu",
      "installation_fencing_pro" : "Aidan asennus",
      "repairs_maintenance_fencing_pro" : "Korjaukset ja huolto",
      "education_savings" : "Koulutussäästöt",
      "estate_financial_planning" : "Perintösuunnittelu",
      "financial_planning" : "Taloussuunnittelu",
      "financial_planning_other" : "Muu",
      "home_purchase" : "Kodin osto",
      "insurance" : "Vakuutus",
      "investment_advising" : "Sijoitusneuvonta",
      "retirement_savings" : "Eläköityminen",
      "tax_planning" : "Verosuunnittelu",
      "advanced_cardiac_life_support" : "Edistynyt sydänelvytys",
      "aed_defibrillator" : "AED - Defibrillaattori",
      "basic_life_support" : "Peruselvytys",
      "cpr" : "Puhallus-paineluelvytys",
      "first_aid" : "Ensiapu",
      "first_aid_trainer_other" : "Muu",
      "pediatric_advanced_life_support" : "Lasten edistynyt elintoimintojen tuki",
      "pediatric_cpr_first_aid" : "Lasten elvytys ja ensiapu",
      "pet_cpr_first_aid" : "Lemmikkien elvytys ja ensiapu",
      "wilderness_first_aid" : "Eräensiapu",
      "baseboards" : "Pohjalevyt",
      "carpet" : "Matto",
      "flooring_other" : "Muu",
      "hardwood" : "Kovapuu",
      "installation_flooring_pro" : "Lattioiden asennus",
      "marble" : "Marmori",
      "polishing" : "Lattian kiillotus",
      "refinishing" : "Lattian viimeistely",
      "repair_maintenance_flooring_pro" : "Lattian korjaus ja ylläpito",
      "stair_flooring" : "Portaiden lattiamateriaali",
      "tile" : "Laatta",
      "wood_floor_sanding" : "Puulattian hionta",
      "basement_waterproofing" : "Kellarin vedeneristys",
      "crawl_spaces" : "Ryömintätilan perustukset",
      "foundation_drainage" : "Perustuksen salaojitus",
      "foundation_installation" : "Perustuksen asennus",
      "foundation_pro_other" : "Muu",
      "foundation_raising" : "Peruuksen nostaminen",
      "repairs_maintenance_foundation_pro" : "Korjaukset ja huolto",
      "slab_foundation" : "Laattaperustus",
      "steel_pier_pilings" : "Teräslaituripaalutukset",
      "water_moisture_control" : "Veden ja kosteuden hallinnta",
      "burials" : "Hautaukset",
      "caskets" : "Ruumisarkut",
      "cremation" : "Krematointi",
      "funeral_home_flowers" : "Kukat",
      "funeral_home_other" : "Muu",
      "funeral_home_transportation_transfers" : "Kuljetukset ja siirrot",
      "funeral_home_veteran_services" : "Veteraanipalvelut",
      "funerals" : "Hautajaiset",
      "gravestones" : "Hautakivet",
      "grief_services" : "Hautajaispalvelut",
      "memorials" : "Muistomerkit",
      "urns" : "Uurnat",
      "garage_door_other" : "Muu",
      "general_maintenance" : "Yleinen huolto",
      "install_garage_door" : "Asenna autotallin ovi",
      "install_opener" : "Asenna avaaja",
      "repair_cables" : "Korjaa kaapelit",
      "repair_garage_door" : "Korjaa autotallin ovi",
      "repair_gate" : "Korjausportti",
      "repair_rollers_tracks" : "Korjaa rullat ja telat",
      "replace_door_panels" : "Vaihda ovipaneelit",
      "replace_opener" : "Korvaa avaaja",
      "replace_springs" : "Vaihda jouset",
      "accessory_buildings" : "Lisärakennukset",
      "bathroom_remodel" : "Kylpyhuoneremontti",
      "decks_patio" : "Kannet ja patio",
      "exterior_finishing" : "Ulkopuolen viimeistely",
      "foundations_concrete" : "Perustukset ja betonityöt",
      "general_contractor_commercial_projects" : "Kaupalliset projektit",
      "general_contractor_other" : "Muu",
      "home_addition" : "Kodin laajennus",
      "home_building" : "Kodin rakennustyöt",
      "home_remodel_renovation" : "Kodinsisustus ja remontointi",
      "interior_finishing" : "Sisätilojen viimeistely",
      "kitchen_remodel" : "Keittiöremontti",
      "roofing" : "Kattotyöt",
      "assemble_furniture" : "Kokoa huonekalu",
      "clean_gutters" : "Puhdista kourut",
      "handyman_other" : "Muu",
      "install_drywall" : "Asenna kipsilevy",
      "install_flooring" : "Asenna lattia",
      "install_tile" : "Asenna laatta",
      "install_water_fixtures" : "Asenna vesikalusteet",
      "mount_tv" : "Asenna TV",
      "paint_indoors" : "Maalaa sisätiloissa",
      "paint_outdoors" : "Maalaa ulkona",
      "repair_drywall" : "Korjaa kipsilevy",
      "repair_flooring" : "Korjaa lattia",
      "repair_water_fixtures" : "Korjaa vesikalusteet",
      "replace_tile" : "Vaihda ruutu",
      "buyer_seller_inspection" : "Ostajan ja kauppiaan tarkastus",
      "commercial_properties" : "Liikehuoneistot",
      "fire_safety" : "Paloturvallisuus",
      "fireplace_chimney" : "Takka ja savupiippu",
      "full_home_inspection" : "Täysi kotitarkastus",
      "home_inspector_electrical" : "Sähköinen",
      "home_inspector_foundation" : "Perustus",
      "home_inspector_hvac" : "HVAC",
      "home_inspector_mold" : "Muotti",
      "home_inspector_new_construction" : "Uudisrakentaminen",
      "home_inspector_other" : "Muu",
      "home_inspector_plumbing" : "Putkityöt",
      "home_inspector_roof" : "Katto",
      "home_inspector_structural" : "Rakenteellinen",
      "home_warranty" : "Kotivakuutus",
      "water_testing" : "Veden testaus",
      "well_or_septic_system" : "Kaivo tai jätevesijärjestelmä",
      "wood_insects" : "Puu ja hyönteiset",
      "access_control" : "Kulunvalvonta",
      "alarm_systems" : "Hälytysjärjestelmät",
      "commercial_security_systems" : "Kaupalliset turvajärjestelmät",
      "fire_smoke_detection" : "Palon ja savun havaitseminen",
      "home_security_doors" : "Ovet",
      "home_security_locks" : "Lukot",
      "home_security_other" : "Muu",
      "home_security_windows" : "Ikkunat",
      "monitoring_services" : "Seurantapalvelut",
      "residential_security_systems" : "Asuntojen turvajärjestelmät",
      "smart_home_integration" : "Älykodin integrointi",
      "video_surveillance" : "Videovalvonta",
      "audio_video_installation" : "Audio-video-asennus",
      "commercial_projects" : "Kaupalliset projektit",
      "home_theater_design" : "Koti teatterin suunnittelu",
      "home_theater_lighting" : "Valaistus",
      "home_theater_other" : "Muu",
      "home_theater_smart_home_integration" : "Älykoti-integraatio",
      "install_tv" : "Asenna TV",
      "network_it_services" : "Verkko- ja IT-palvelut",
      "outdoor_installations" : "Ulkoasennukset",
      "soundproofing" : "Äänieristys",
      "whole_house_audio_video" : "Koko talon audio-videojärjestelmä",
      "ac_maintenance" : "Ilmastointihuolto",
      "clean_ducts_vents" : "Puhdista kanavat ja tuuletusaukot",
      "ductless_heating_and_ac_services" : "Ilman kanavia toimivat lämmitys- ja ilmastointipalvelut",
      "heating_maintenance" : "Lämmityshuolto",
      "hvac_maintenance" : "LVI-huolto",
      "hvac_other" : "Muu",
      "install_ac" : "Asenna ilmastointi",
      "install_ducts_vents" : "Asenna kanavat ja tuuletusaukot",
      "install_heating_system" : "Asenna lämmitysjärjestelmä",
      "install_thermostat" : "Asenna termostaatti",
      "repair_ac" : "Korjaa ilmastointilaite",
      "repair_ducts_vents" : "Korjaa kanavat ja tuuletusaukot",
      "repair_heating_system" : "Korjaa lämmitysjärjestelmä",
      "repair_hvac" : "Korjaa LVI-järjestelmä",
      "repair_thermostat" : "Korjaa termostaatti",
      "asylum" : "Turvapaikka",
      "citizenship" : "Kansalaisuus",
      "deportation" : "Karkotus",
      "family_based_immigration" : "Perheperusteinen maahanmuutto",
      "green_card" : "Green Card -kortti",
      "immigration_lawyer_other" : "Muu",
      "investment_visa" : "Investointiviisumi",
      "outbound_work_permits" : "Lähtevät työluvat",
      "student_visa" : "Opiskelijaviisumi",
      "visitor_visa" : "Vierailijaviisumi",
      "work_visa" : "Työviisumi",
      "appliance_selection" : "Laitteen valinta",
      "cabinetry_molding_hardware_design" : "Kaluste- ja laitteistosuunnittelu",
      "decorating" : "Sisustaminen",
      "door_design" : "Oven muotoilu",
      "exterior_building_design" : "Rakennuksen ulkoinen muotoilu",
      "flooring_selection" : "Lattian valinta",
      "interior_designer_other" : "Muu",
      "landscaping_design" : "Maisemasuunnittelu",
      "lighting_design" : "Valaistussuunnittelu",
      "multifamily_housing_design" : "Moniperheasuntojen muotoilu",
      "room_planning" : "Huonesuunnittelu",
      "stone_brick_stucco_design" : "Kivi-, tiili- ja stukkisuunnittelu",
      "window_design" : "Ikkunan muotoilu",
      "advertisements" : "Mainokset",
      "copyright" : "Tekijänoikeus",
      "export_control" : "Viennin valvonta",
      "franchises" : "Franchising-yritykset",
      "international_ip" : "Kansainvälinen IP-osoite",
      "ip_lawyer_other" : "Muu",
      "ip_strategy" : "IP-strategia",
      "ip_transactions" : "IP-tapahtumat",
      "licensing" : "Toimilupa",
      "litigation_ip_lawyer" : "Oikeudenkäynti",
      "non_disclosure_agreements_ip_lawyer" : "Salassapitosopimukset",
      "patents" : "Patentit",
      "technology_transfer" : "Teknologian siirto",
      "trade_secrets" : "Kauppasalaisuudet",
      "trademarks" : "Tavaramerkit",
      "appliance_removal" : "Laitteen poistaminen",
      "construction_waste_removal" : "Rakennusjätteen poisto",
      "donation_pickup" : "Lahjoitusten nouto",
      "electronic_waste_removal" : "Elektroniikkajätteen poisto",
      "furniture_removal" : "Huonekalujen poisto",
      "general_junk_removal" : "Yleinen jätteenpoisto",
      "hazardous_waste_removal" : "Vaarallisen jätteen poisto",
      "house_garage_cleanout" : "Talon/autotallin siivous",
      "junk_removal_other" : "Muu",
      "yard_waste_removal" : "Pihajätteen poisto",
      "employment_contracts_labor_lawyer" : "Työsopimukset",
      "employment_law_labor_lawyer" : "Työlainsäädäntö",
      "exempt_employee_status" : "Vapautetun työntekijän tila",
      "labor_law" : "Työlainsäädäntö",
      "labor_lawyer_other" : "Muu",
      "labor_negotiations" : "Työneuvottelut",
      "privacy_rights" : "Tietosuojakäytännöt",
      "sexual_harassment" : "Seksuaalinen häirintä",
      "unpaid_overtime" : "Maksamattomat ylityötunnit",
      "whistle_blowing" : "Ilmianto",
      "workers_compensation_labor_lawyer" : "Työtapaturmavakuutus",
      "wrongful_termination" : "Laiton irtisanominen",
      "artificial_turf_installation" : "Tekonurmen asennus",
      "concrete_masonry" : "Betonimuuraukset",
      "driveway_landscaping" : "Ajotien maisemointi",
      "garden_decorations" : "Puutarhan koristeet",
      "grading_resloping" : "Tasoitus ja kaltevuuden korjaus",
      "hardscapes" : "Kovapintaiset maisemat",
      "landscape_design" : "Maaston muotoilu",
      "landscape_installations" : "Maisemainstallaatiot",
      "landscaper_other" : "Muu",
      "outdoor_steps" : "Ulkoportaat",
      "outdoor_water_feature" : "Ulkona sijaitsevat vesielementit",
      "paving_driveway_walkway" : "Ajotien tai kävelytien päällystys",
      "retaining_walls" : "Tukimuurit",
      "sidewalk_walkway_landscaping" : "Kävelytien maisemointi.",
      "sod_seeding" : "Turve ja kylvö",
      "stone_masonry" : "Kivimuuraukset",
      "arabic" : "arabia",
      "english" : "englanti",
      "french" : "ranska",
      "german" : "saksa",
      "hebrew" : "heprea",
      "italian" : "italia",
      "japanese" : "japani",
      "korean" : "korea",
      "language_instructor_other" : "Muu",
      "mandarin" : "mandariinikiina",
      "portuguese" : "portugali",
      "russian" : "venäjä",
      "sign_language" : "Viittomakieli",
      "spanish" : "espanja",
      "irrigation_system_repair_maintenance" : "Kastelujärjestelmän korjaus / huolto",
      "lawn_care_other" : "Muu",
      "lawn_mowing_maintenance" : "Ruohonleikkuu / huolto",
      "lawn_pest_control" : "Nurmikon tuholaistorjunta",
      "mulching" : "Multaus",
      "seeding" : "Kylvö",
      "sod_installation" : "Siirtonurmen asennus",
      "weed_control" : "Rikkakasvien torjunta",
      "yard_cleanup" : "Pihan siivous",
      "appeals" : "Valitukset",
      "case_assessment_litigation_lawyer" : "Tapausten arviointi",
      "civil_litigation" : "Siviilioikeudenkäynti",
      "commercial_litigation" : "Kaupallinen riidanratkaisu",
      "contracts_and_agreements" : "Sopimukset ja sopimukset",
      "criminal_litigation" : "Rikosoikeudelliset oikeudenkäynnit",
      "litigation_lawyer_other" : "Muu",
      "mediation_litigation_lawyer" : "Sovittelu",
      "settlements" : "Maksutapahtumat",
      "building_lockout" : "Rakennuksen lukitusjärjestelmä",
      "copy_building_key" : "Teetä koipioita rakennusavaimista",
      "copy_vehicle_key" : "Teetä koipioita ajoneuvon avaimesta",
      "install_hardware" : "Asenna laitteisto",
      "locksmith_other" : "Muu",
      "new_key_fob" : "Uusi avaimenperä",
      "rekey_lock" : "Uudelleenkoodaa lukko",
      "repair_hardware" : "Laitteiston korjaus",
      "vehicle_lockout" : "Ajoneuvon lukitus",
      "consent_issues" : "Suostumusasiat",
      "diagnosis_errors" : "Diagnoosivirheet",
      "malpractice_lawyer_other" : "Muu",
      "medical_negligence" : "Lääketieteellinen laiminlyönti",
      "treatment_errors" : "Hoitovirheet",
      "massage_center_other" : "Muu",
      "massage_school_advanced_neuromuscular_therapy" : "Kehittynyt neuromuskulaariterapia",
      "massage_school_business_and_ethics" : "Liiketoiminta ja etiikka",
      "massage_school_clinical_therapies" : "Kliiniset hoitomuodot",
      "massage_school_continuing_education" : "Täydennyskoulutus",
      "massage_school_deep_tissue_massage" : "Syväkudoshieronta",
      "massage_school_energetics" : "Energetiikka",
      "massage_school_hydrotherapy" : "Vesiterapia",
      "massage_school_lymphatic_massage" : "Lymfahieronta",
      "massage_school_online_massage_therapy" : "Online-hierontaterapia",
      "massage_school_other" : "Muu",
      "massage_school_prenatal_massage" : "Raskausajan hieronta",
      "massage_school_sports_massage" : "Urheiluhieronta",
      "massage_school_student_massage_clinic" : "Opiskelijahierontaklinikka",
      "massage_school_swedish_massage" : "Ruotsalainen hieronta",
      "massage_theory" : "Hierontateoria",
      "massage_therapy_training" : "Hierontaterapiakoulutus",
      "in_state_move" : "Muutto osavaltion sisällä",
      "local_move" : "Paikallinen muutto",
      "mover_other" : "Muu",
      "moving_junk_removal" : "Roskan poisto",
      "moving_storage" : "Tallennus",
      "out_of_state_move" : "Muutto osavaltion ulkopuolelle",
      "oversized_item_move" : "Ylisuuren tavaran siirto",
      "packing_unpacking" : "Pakkaaminen/purkaminen",
      "senior_move" : "Seniorimuutto",
      "vehicle_transport" : "Ajoneuvokuljetus",
      "cardiac_care" : "Sydänhoito",
      "general_medical_care" : "Yleinen terveydenhoito",
      "hospice" : "Saattohoito",
      "iv_therapy" : "IV-terapia",
      "nursing_home_meal_services" : "Ateriapalvelut",
      "nursing_home_memory_care" : "Muistisairauksien hoito",
      "nursing_home_other" : "Muu",
      "nursing_home_pain_management" : "Kivunhallinta",
      "nursing_home_rehabilitation_services" : "Kuntoutuspalvelut",
      "nursing_home_wellness_programs" : "Hyvinvointiohjelmat",
      "outpatient_rehabilitation" : "Avokuntoutus",
      "post_hospital_care" : "Sairaalahoidon jälkeinen hoito",
      "respiratory_and_pulmonary_care" : "Hengityselinten ja keuhkojen hoito",
      "senior_activity_programs" : "Senioreiden toimintaohjelmat",
      "short_term_rehabilitation" : "Lyhytaikainen kuntoutus",
      "wound_care" : "Haavanhoito",
      "exterior_painting" : "Ulkomaalaus",
      "interior_painting" : "Sisämaalaus",
      "paint_cabinets" : "Maalaa kaapit",
      "paint_doors" : "Maalaa ovet",
      "painter_other" : "Muu",
      "repair_water_damage" : "Korjaa vesivahinko",
      "staining" : "Värjäys",
      "assault_battery" : "Pahoinpitely ja väkivalta",
      "auto_accidents" : "Auto-onnettomuudet",
      "bicycle_accidents" : "Polkupyöräonnettomuudet",
      "catastrophic_injuries" : "Katastrofaaliset vammat",
      "dog_bites" : "Koiran puremat",
      "dui_injuries_personal_injury_lawyer" : "Rattijuopumuksen aiheuttamat vammat",
      "medical_malpractice" : "Lääketieteellinen hoitovirhe",
      "motorcycle_accidents" : "Moottoripyöräonnettomuudet",
      "pain_suffering" : "Kipu ja kärsimys",
      "pedestrian_accidents" : "Jalankulkijaonnettomuudet",
      "personal_injury_lawyer_other" : "Muu",
      "product_liability" : "Tuotevastuu",
      "slip_fall" : "Liukastuminen ja kaatuminen",
      "uninsured_motorist_claims" : "Autoilijan vakuutuskorvaukset",
      "workers_compensation_personal_injury_lawyer" : "Työtapaturmavakuutus",
      "wrongful_death" : "Väärästä toiminnasta johtuva kuolema",
      "aerobics" : "Aerobic-tunti",
      "athletic_performance" : "Urheilullinen suorituskyky",
      "circuit_training" : "Piiriharjoittelu",
      "endurance" : "Kestävyys",
      "fitness_assessment" : "Kuntoarviointi",
      "hiit" : "HIIT",
      "nutritional_counseling" : "Ravitsemusneuvonta",
      "personal_trainer_other" : "Muu",
      "strength_conditioning" : "Voima ja kunto",
      "weight_loss" : "Painonpudotus",
      "yoga" : "Jooga",
      "ants" : "Muurahaiset",
      "bed_bugs" : "Luteet",
      "bees" : "Mehiläiset",
      "cockroaches" : "Torakat",
      "fleas_or_mites" : "Kirput tai punkit",
      "hornets_or_wasps" : "Ampiaiset tai mehiläiset",
      "mosquitoes" : "Hyttyset",
      "pest_control_other" : "Muu",
      "pest_inspection" : "Tarkastus",
      "rodents" : "Jyrsijät",
      "spiders" : "Hämähäkit",
      "termites" : "Termiitit",
      "wildlife" : "Villieläimet",
      "pet_adoption_birds" : "Linnut",
      "pet_adoption_cats" : "Kissat",
      "pet_adoption_dogs" : "Koirat",
      "pet_adoption_farm_animals" : "Maatilaeläimet",
      "pet_adoption_fish" : "Kala",
      "pet_adoption_other" : "Muu",
      "pet_adoption_reptiles" : "Matelijat",
      "pet_adoption_small_mammals" : "Pienet nisäkkäät",
      "pet_adoption_special_needs_animals" : "Erityistarpeiset eläimet",
      "cat_boarding" : "Kissahoitola",
      "cat_grooming" : "Kissan hoito",
      "cat_sitting_in_home" : "Kissan hoito (kotona)",
      "dog_boarding" : "Koirahoitola",
      "dog_boarding_with_training" : "Koirien hoito ja kurssit",
      "dog_daycare" : "Koirapäiväkoti",
      "dog_grooming" : "Koiran hoito",
      "dog_sitting_in_home" : "Koiran hoito (kotona)",
      "dog_training" : "Koiran koulutus",
      "dog_walking" : "Koiran ulkoilutus",
      "other_pet_boarding" : "Muu lemmikkien majoitus",
      "other_pet_daycare" : "Muu lemmikkipäivähoito",
      "other_pet_grooming" : "Muu lemmikkien trimmaus",
      "other_pet_sitting_in_home" : "Muu lemmikkien hoito (kotona)",
      "pet_boarding_other" : "Muu",
      "cat_bathing" : "Kissan peseminen",
      "cat_ear_cleaning" : "Kissan korvien puhdistus",
      "cat_grooming_and_styling" : "Kissan hoito ja muotoilu",
      "cat_nail_trimming" : "Kissan kynsien leikkaaminen",
      "dog_anal_gland_expression" : "Koiran anaalirauhasen tyhjennys",
      "dog_bathing_and_blow_dry" : "Koiran pesu ja föönaus",
      "dog_ear_cleaning" : "Koiran korvien puhdistus",
      "dog_flea_and_tick_treatment" : "Koiran kirppu- ja punkkihoito",
      "dog_full_service_grooming" : "Koiran täyden palvelun trimmaus",
      "dog_grooming_and_styling" : "Koiran trimmaus ja turkin muotoilu",
      "dog_nail_trimming" : "Koiran kynsien leikkaus",
      "dog_teeth_brushing" : "Koiran hampaiden puhdistus",
      "pet_grooming_other" : "Muu",
      "aggressive_dog_training" : "Aggressiivisen koiran koulutus",
      "behavior_modification" : "Käyttäytymisen muuttaminen",
      "obedience_training" : "Tottelevaisuuskoulutus",
      "offleash_training" : "Koulutus ilman talutushihnaa",
      "pet_trainer_other" : "Muu",
      "puppy_training" : "Pennun koulutus",
      "service_animal_training" : "Palvelueläinkurssit",
      "sport_trick_training" : "Urheilu- tai temppuilu",
      "training_other_animals" : "Muiden eläinten koulutus",
      "corporate_photo" : "Yritys",
      "events_and_parties_photo" : "Tapahtumat ja juhlat",
      "family_and_group_photo" : "Perhe ja ryhmä",
      "headshots_and_portraits" : "Kasvokuvat ja muotokuvat",
      "individual_photo" : "Henkilökohtainen",
      "maternity_and_newborn_photo" : "Äitiys ja vastasyntynyt",
      "photographer_other" : "Muu",
      "product_photo" : "Tuote",
      "real_estate_photo" : "Kiinteistöala",
      "school_portraits" : "Koulukuvat",
      "wedding_and_engagement_photo" : "Häät ja kihlaus",
      "find_leak" : "Vuodon etsiminen ja korjaaminen",
      "install_faucet" : "Asenna hana",
      "install_garbage_disposal" : "Jätehuoltojärjestelmän korjaus",
      "install_shower" : "Asenna suihku",
      "install_toilet" : "Asenna WC-istuin",
      "install_water_heater" : "Asentaa vedenlämmitin",
      "plumbing_other" : "Muu",
      "repair_faucet" : "Hanan korjaus",
      "repair_garbage_disposal" : "Jätehuoltojärjestelmän korjaus",
      "repair_outdoor_systems" : "Ulkojärjestelmien korjaus",
      "repair_pipe" : "Korjaa putki",
      "repair_sewer" : "Korjaa viemäri",
      "repair_shower" : "Suihkun korjaus",
      "repair_toilet" : "Korjaa WC",
      "repair_water_heater" : "Vedenlämmittimen korjaus",
      "unclog_drain" : "Avaa viemärin tukos",
      "commercial_pool_cleaning_maintenance" : "Kaupallisten uima-altaiden puhdistus ja ylläpito",
      "equipment_maintenance_repair" : "Laitteiden huolto ja korjaus",
      "one_time_pool_cleaning" : "Kertaluonteinen altaan puhdistus",
      "ongoing_pool_cleaning" : "Jatkuva altaan puhdistus",
      "pool_cleaner_other" : "Muu",
      "pool_cleaner_water_features" : "Vesielementit",
      "seasonal_opening_closing" : "Kausittainen avaus ja sulkeminen",
      "spa_hot_tub_cleaning" : "Kylpylä- ja poreallaspuhdistus",
      "spa_hot_tub_repairs" : "Kylpylä- ja porealtaiden korjaukset",
      "tile_pool_wall_cleaning" : "Laattojen ja allasseinien puhdistus",
      "water_testing_balancing" : "Veden testaus ja tasapainotus",
      "jetted_lap_pools" : "Suihkualtaat",
      "pool_construction" : "Uima-altaan rakentaminen",
      "pool_contractor_commercial_projects" : "Kaupalliset projektit",
      "pool_contractor_custom_designs" : "Mukautetut mallit",
      "pool_contractor_other" : "Muu",
      "pool_contractor_renovation" : "Remontti",
      "pool_contractor_repair_cracks" : "Halkeamien korjaus",
      "pool_contractor_repair_tile" : "Korjauslaatta",
      "pool_contractor_resurfacing" : "Uudelleenpinnoitus",
      "pool_contractor_water_features" : "Vesielementit",
      "pool_hot_tub_equipment" : "Uima-altaan ja porealtaan laitteet",
      "spa_hot_tub_installation" : "Kylpylä- ja porealtaan asennus",
      "bilingual_programs" : "Kaksikieliset ohjelmat",
      "early_preschool" : "Varhaiskasvatus",
      "full_day_preschool" : "Kokopäiväinen esikoulu",
      "half_day_preschool" : "Puolipäiväesikoulu",
      "kindergarten_classes" : "Päiväkotiluokat",
      "montessori_programs" : "Montessori-ohjelmat",
      "play_based_preschool" : "Leikkipohjainen esikoulu",
      "preschool_infant_programs" : "Vauvaohjelmat",
      "preschool_other" : "Muu",
      "reggio_emilia_preschool" : "Reggio Emilia -esikoulu",
      "special_needs_programs" : "Erityistarpeiden ohjelmat",
      "summer_camp" : "Kesäleiri",
      "waldorf_preschool" : "Waldorf-esikoulu",
      "psychologist_other" : "Muu",
      "buyer_agent" : "Ostajan edustaja",
      "first_time_home_buyer" : "Ensiasunnon ostaja",
      "foreclosed_properties" : "Ulosotetut kiinteistöt",
      "luxury_properties" : "Ylelliset kiinteistöt",
      "new_construction" : "Uudisrakentaminen",
      "property_management" : "Kiinteistön hallinta",
      "real_estate_agent_other" : "Muu",
      "relocation" : "Uudelleensijoittaminen",
      "rentals" : "Vuokraukset",
      "sellers_agent" : "Myyjän edustaja",
      "commercial_real_estate" : "Kaupallinen kiinteistöala",
      "easements" : "Käyttöoikeudet",
      "encroachment" : "Tunkeutuminen",
      "foreclosure_real_esate_lawyer" : "Ulosmittaus",
      "landlord_tenant_law" : "Vuokranantaja- ja vuokralainsäädäntö",
      "litigation_real_estate_lawyer" : "Oikeudenkäynti",
      "mortgage_lending_law" : "Asuntolaina- ja lainalainsäädäntö",
      "neighbor_hoa_disputes" : "Naapuri- ja asunto-osakeyhtiöriidat",
      "property_damage" : "Omaisuusvahinko",
      "purchase_agreements" : "Ostosopimukset",
      "real_estate_contracts_transactions" : "Kiinteistökaupat",
      "real_estate_lawyer_other" : "Muu",
      "residential_real_estate" : "Asuinrakennusala",
      "title_services" : "Omistusoikeuspalvelut",
      "trespassing" : "Luvaton pääsy",
      "rehab_other" : "Muu",
      "attic_venting" : "Ullakon tuuletus",
      "gutter_installation" : "Kourujen asennus",
      "gutter_repair" : "Kourujen korjaus",
      "roof_inspection" : "Katon tarkastus",
      "roof_installation" : "Kattoasennus",
      "roof_repair" : "Katon korjaus",
      "roofer_other" : "Muu",
      "skylight_installation" : "Kattoikkunan asennus",
      "skylight_repair" : "Kattoikkunan korjaus",
      "storm_wind_damage_roof_repair" : "Kattovaurioiden korjaus",
      "sewage_cleaning" : "Siivous",
      "sewage_excavation" : "Kaivaminen",
      "sewage_inspection" : "Tarkastus",
      "sewage_installation" : "Asennus",
      "sewage_locating" : "Sijainnin etsiminen",
      "sewage_maintenance_repairs" : "Huolto ja korjaukset",
      "sewage_pro_other" : "Muu",
      "sewage_pumping" : "Pumppaus",
      "sewage_removal_demolition" : "Poistaminen tai purku",
      "remodeling_siding_pro" : "Uudistaminen",
      "repair_maintenance_siding_pro" : "Korjaus ja ylläpito",
      "siding_installation" : "Verhouksen asennus",
      "siding_pro_other" : "Muu",
      "siding_removal" : "Verhouksen poisto",
      "smart_home_other" : "Muu",
      "commercial_snow_removal" : "Kaupallinen lumenpoistopalvelu",
      "residential_plowing" : "Asuinalueiden auraus",
      "residential_shoveling_blowing" : "Asuinalueiden lumityöt ja lumen puhallus",
      "salt_sand_deicing" : "Suola, hiekka ja jäänsulatus",
      "snow_relocation" : "Lumen siirtäminen",
      "snow_removal_other" : "Muu",
      "body_polish" : "Rungon kiillotus",
      "body_wrap" : "Vartalokääre",
      "facial" : "Kasvohoito",
      "hydrotherapy" : "Vesiterapia",
      "manicure" : "Manikyyri",
      "massage" : "Hieronta",
      "pedicure" : "Pedikyyri",
      "peels" : "Kuoriutuu",
      "spa_other" : "Muu",
      "spa_packages" : "Kylpyläpaketit",
      "tanning" : "Rusketus",
      "waxing" : "Vahaus",
      "civil_tax_litigation" : "Siviiliverotukseen liittyvät oikeudenkäynnit",
      "corporate_taxes" : "Yritysverotus",
      "criminal_tax_litigation" : "Rikosoikeudellinen veroriita",
      "estate_tax_planning" : "Perintöverosuunnittelu",
      "failure_to_file" : "Laiminlyönti ilmoituksen tekemisessä.",
      "innocent_spouse_relief" : "Viattoman puolison avustus",
      "international_tax_services" : "Kansainväliset veropalvelut",
      "irs_tax_problems" : "Vero-ongelmat",
      "non_collectible_status" : "Perintäkelvoton tila",
      "offer_in_compromise" : "Sovintotarjous",
      "tax_audits" : "Verotarkastukset",
      "tax_lawyer_other" : "Muu",
      "tax_liens_levies" : "Verolainat ja -ulosmittaukset",
      "tax_planning_lawyer" : "Verosuunnittelu",
      "tax_relief" : "Verohelpotukset",
      "accounting_support" : "Kirjanpidon tuki",
      "business_incorporation_restructuring" : "Yhtiöittäminen & uudelleenjärjestely",
      "cryptocurrency_taxes" : "Kryptovaluuttaverot",
      "irs_audit_representation" : "Verotarkastuksen edustus",
      "irs_filing" : "IRS-ilmoitus",
      "irs_problem_consulting" : "IRS-ongelmakonsultointi",
      "new_business_services" : "Uusyrityspalvelut",
      "payroll_support" : "Palkanlaskennan tuki",
      "tax_planning_tax_specialist" : "Verosuunnittelu",
      "tax_preparation" : "Veron valmistelu",
      "tax_problem_consulting_tax_specialist" : "Vero-ongelmien konsultointi",
      "tax_specialist_other" : "Muu",
      "therapist_other" : "Muu",
      "battery_service" : "Akkupalvelu",
      "car_towing" : "Auton hinauspalvelu",
      "fuel_delivery" : "Polttoaineen toimitus",
      "local_hauling" : "Paikallinen kuljetus",
      "long_distance_hauling" : "Pitkän matkan rahti",
      "motorcycle_towing" : "Moottoripyörän hinaus",
      "special_vehicle_towing" : "Erityisajoneuvojen hinauspalvelu",
      "tire_change" : "Renkaanvaihto",
      "towing_other" : "Muu",
      "case_assessment_traffic_lawyer" : "Tapausten arviointi",
      "cdl_traffic_ticket" : "CDL-liikennesakko",
      "dui_dwi_traffic_lawyer" : "DUI",
      "fixit_ticket" : "Korjauslippu",
      "parking_ticket" : "Pysäköintisakko",
      "reckless_driving_traffic_lawyer" : "Holtiton ajo",
      "red_light_ticket" : "Punaisen valon lippu",
      "speeding_ticket" : "Ylinopeussakko",
      "suspended_license" : "Keskeytetty lisenssi",
      "traffic_lawyer_other" : "Muu",
      "traffic_ticket" : "Liikennesakkolappu",
      "cabling_and_bracing" : "Kaapelointi ja tukeminen",
      "stump_removal" : "Kantojen poisto",
      "tree_planting" : "Puiden istutus",
      "tree_removal" : "Puun poisto",
      "tree_service_other" : "Muu",
      "tree_transplanting" : "Puiden siirtäminen",
      "tree_trimming_and_pruning" : "Puiden leikkaus ja karsinta",
      "tutor_computer_science" : "Tietojenkäsittelytiede",
      "tutor_foreign_languages" : "Vieraat kielet",
      "tutor_geography" : "Geografia",
      "tutor_government_and_economics" : "Julkinen hallinto ja taloustiede",
      "tutor_history" : "Historia",
      "tutor_homework_help" : "Läksyapu",
      "tutor_math" : "Matematiikka",
      "tutor_other" : "Muu",
      "tutor_reading_and_writing" : "Lukeminen ja kirjoittaminen",
      "tutor_science" : "Tiede",
      "tutor_special_education" : "Erityisopetus",
      "tutor_test_pre_college_entrance" : "Testiin valmistautuminen: yliopistoon pääsy",
      "tutor_test_prep_grad_school_entrance" : "Testivalmistelu: Jatko-opintoihin pääsy",
      "tutor_test_prep_k8" : "Testivalmistelu: K-8",
      "area_rug_cleaning" : "Kokolattiamaton puhdistus",
      "drapery_and_blind_cleaning" : "Verhojen ja kaihtimien puhdistus",
      "leather_cleaning" : "Nahan puhdistus",
      "mattress_cleaning" : "Patjan puhdistus",
      "upholstery_cleaner_other" : "Muu",
      "upholstery_cleaning" : "Verhoilun puhdistus",
      "upholstery_water_damage_cleanup" : "Vesivahinkojen siivous",
      "bird_exotic_animal_care" : "Lintujen ja eksoottisten eläinten hoito",
      "farm_barn_animal_care" : "Maatilan ja navetan eläinten hoito",
      "microchipping" : "Mikrosirutus",
      "veterinarian_allergies" : "Allergiat",
      "veterinarian_behavior_counseling" : "Käyttäytymisen ohjaus",
      "veterinarian_dental_care" : "Hammashoito",
      "veterinarian_dermatology" : "Dermatologia",
      "veterinarian_emergency_care" : "Ensiapu",
      "veterinarian_end_of_life_care" : "Elämän loppuvaiheen hoito",
      "veterinarian_examinations" : "Tarkastukset",
      "veterinarian_nutrition_counseling" : "Ravitsemusneuvonta",
      "veterinarian_other" : "Muu",
      "veterinarian_preventive_care" : "Ennaltaehkäisevä hoito",
      "veterinarian_spay_neuter" : "Sterilointi tai kastrointi",
      "veterinarian_surgery" : "Leikkaus",
      "veterinarian_vaccinations" : "Rokotukset",
      "aerial_videography" : "Ilmavideokuvaus",
      "documentary_video_production" : "Dokumenttituotanto",
      "family_video_production" : "Perhevideotuotanto",
      "live_streaming" : "Suoratoisto",
      "photography" : "Valokuvaus",
      "product_demonstrations" : "Tuote-esittely",
      "promotional_video_production" : "Mainosvideon tuotanto",
      "real_estate_video_production" : "Kiinteistöalan videotuotanto",
      "special_event_video_production" : "Erikoistapahtumien videotuotanto",
      "video_editing" : "Videon editointi",
      "videographer_other" : "Muu",
      "voice_overs" : "Äänikerronta",
      "wedding_video_production" : "Häävideoiden tuotanto",
      "fire_damage_cleanup_repair" : "Palovahinkojen puhdistus / korjaus",
      "water_damage_cleanup_repair" : "Vesivahinkojen siivous",
      "water_damage_flooring" : "Lattiapäällyste",
      "water_damage_mold_inspection" : "Homeen tarkastus",
      "water_damage_mold_removal" : "Homeenpoisto",
      "water_damage_other" : "Muu",
      "water_damage_painting" : "Maalaus",
      "water_damage_pest_control" : "Tuholaistorjunta",
      "water_damage_plumbing" : "Putkityöt",
      "water_damage_remodeling" : "Uudistaminen",
      "water_damage_roofing" : "Kattotyöt",
      "water_damage_sewage_cleanup" : "Viemärinpuhdistus",
      "adult_weight_loss_programs" : "Aikuisten painonpudotusohjelmat",
      "diet_and_nutrition_counseling" : "Ruokavalio- ja ravitsemusneuvonta",
      "kids_weight_loss_programs" : "Lasten paino-ohjelmat",
      "metabolic_testing" : "Metabolinen testaus",
      "weight_loss_consultation_and_training" : "Konsultointi ja koulutus",
      "weight_loss_fitness_programs" : "Kunto-ohjelmat",
      "weight_loss_meal_planning" : "Ateriasuunnittelu",
      "weight_loss_personal_training" : "Henkilökohtainen valmennus",
      "weight_loss_service_other" : "Muu",
      "weight_loss_wellness_programs" : "Hyvinvointiohjelmat",
      "glass_and_mirror_cleaning" : "Lasien ja peilien puhdistus",
      "gutter_cleaning" : "Kourujen puhdistus",
      "power_pressure_washing" : "Teho-/painepesu",
      "rooftop_skylight_cleaning" : "Katon/kattoikkunoiden puhdistus",
      "window_cleaner_other" : "Muu",
      "window_cleaning" : "Ikkunoiden pesu",
      "door_installation" : "Oven asennus",
      "door_repair" : "Oven korjaus",
      "glass_installation" : "Lasin asennus",
      "window_boardup" : "Laudoittaminen",
      "window_installation" : "Ikkunan asennus",
      "window_repair" : "Ikkunan korjaus",
      "window_repair_other" : "Muu",
      "install_new_wiper_blades" : "Asenna uudet pyyhkijänsulat",
      "repair_power_window" : "Korjaa sähköikkuna",
      "repair_water_leak" : "Vesivuodon korjaus",
      "repair_windshield" : "Tuulilasin korjaus",
      "replace_rear_window" : "Vaihda takaikkuna",
      "replace_side_view_mirrors" : "Korjaa sivupeilit",
      "replace_side_window" : "Sivuikkunan vaihto",
      "replace_sunroof" : "Kattoluukun lasin vaihto",
      "replace_windshield" : "Vaihda tuulilasi",
      "windshield_other" : "Muu",
      "ashtanga" : "Ashtanga",
      "hatha" : "Hatha",
      "hot_yoga" : "Kuuma jooga",
      "iyengar" : "Iyengar",
      "kundalini" : "Kundalini",
      "meditation" : "Meditaatio",
      "power_yoga" : "Voimajooga",
      "restorative" : "Palauttava",
      "vinyasa" : "Vinyasa",
      "yin" : "Yin",
      "yoga_instructor_other" : "Muu"
    }
  }
}
